import { LOCALES } from "../constants";
const en = {
  [LOCALES.EN]: {
    //All page
    "Página não encontrada": "Page not found",
    //LOGIN
    "login.Login": "Login",
    "login.Informe seu e-mail": "Enter your e-mail",
    "login.E-mail inválido. Por favor, verifique":
    "Invalid e-mail. Please, check",
    "login.Senha": "Password",
    "login.Sua senha deve possuir no mínimo 6 caracteres":
    "Your password must have at least 6 characters",
    "login.Permanecer conectado": "Stay connected",
    "login.Esqueci minha senha": "Forgot my password",
    "login.ENTRAR": "ENTER",
    "login.CRIAR CONTA": "CREATE ACCOUNT",
    "login.Não foi possÍvel fazer o login. Verifique seus dados e tente novamente":
    "It was not possible to login. Check your data and try again",
    "login.Solicitar Acesso": "Request access",
    "login.Utilize esta opção caso possua apenas fornos da versão antiga, que não geram PIN.":
    "Use this option in case you have only old version ovens, which do not generate PIN.",
    "login.A PLATAFORMA IOK MUDOU!": "THE IOK PLATFORM HAS CHANGED!",
    "login.Não exibir este aviso novamente": "Do not show this notice again",
    "login.Se você já possui um cadastro na antiga plataforma, ": "If you already have a registration on the former platform, ",
    "login.clique aqui": "click here",
    "login. para": " to ",
    "login.migrar": "migrate ",
    "login.seus dados e aproveitar toda a experiência IOK.": "your data and enjoy the full IOK experience.",
    "login.Sua conta não foi ativada. Por gentileza, verifique seu e-mail para realizar a ativação":
    "Your account has not been activated. Please, verify your e-mail to activate it",
    "login.Para solicitar acesso a uma organização, o nome informado por você deve ser exatamente o mesmo cadastrado pelo administrador da conta. Em caso de dúvida, procure o responsável pela rede.":
    "To request access to an organization, the name you provide must be exactly the same as registered by the account's administrator. If in doubt, search for the chain responsible.",
    "login.PLATAFORMA EM MANUTENÇÃO": "PLATFORM UNDER MAINTENANCE",
    "login.ESTAMOS PREPARANDO A NOVA PLATAFORMA IOK E EM BREVE ELA ESTARÁ PRONTA!": "WE ARE PREPARING THE NEW IOK PLATFORM AND IT WILL BE READY SOON!",
    "login.Migrar Conta": "Migrate Account",
    "login.Se você já possui um cadastro na antiga plataforma, clique aqui em Migrar Conta para migrar seus dados e aproveitar toda a experiência IOK": "If you already have a registration on the old platform, click here on Migrate Account to migrate your data and enjoy the entire IOK experience",
    "login.Política de privacidade": "Privacy Policy",
    "login.ENTENDI": "OK",
    "login.Para melhorar a sua experiência na plataforma e oferecer serviços personalizados, utilizamos cookies.": "We use cookies to improve your experience on the platform and offer personalized services.",
    "login.Ao utilizar a Plataforma IOK, você automaticamente concorda com seu uso.": "By using the IOK Platform, you automatically agree to its use.",
    "login.Senha incorreta! Duas tentativas restantes antes de ter o acesso à conta bloqueado.": "Incorrect password! Two attempts remaining before access to the account is blocked.",
    "login.Senha incorreta! Uma tentativa restantes antes de ter o acesso à conta bloqueado.": "Incorrect password! One attempt remaining before access to the account is blocked.",
    "login.Acesso bloqueado! Siga as instruções de recuperação de conta.": "Access blocked! Follow the account recovery instructions.",
    
    // REGISTER
    "DISTRIBUIDOR": "DISTRIBUTOR:I am a distributor of Prática equipment.",
    "REDE": "CHAIN: I own a chain.",
    "DONO": "COMPANY: I own my own company/I am part of a chain.",
    "register.Informe seu e-mail cadastrado na plataforma IOK anterior": "Enter your email registered on the previous IOK platform",
    "register.E-mail inválido. Por favor, verifique": "Invalid e-mail. Please, check",
    "register.BUSCAR DADOS": "SEARCH DATA",
    "register.Nome da organização": "Organization name",
    "register.Informe o nome de sua organização": "Enter your organization's name",
    "register.O campo nome da organização é obrigatório": "The organization's name field is required",
    "register.Este nome já existe. Por favor, escolha outro": "This name already exists. Please, choose another one",
    "register.RECUPERAR CONTA": "RETRIEVE ACCOUNT",
    "register.O ADMINISTRADOR DA ORGANIZAÇÃO RECEBERÁ UM E-MAIL PARA ATIVAR SUA CONTA DE USUÁRIO. POR GENTILIZA, AGUARDE": "THE ORGANIZATION ADMINISTRATOR WILL RECEIVE AN EMAIL TO ACTIVATE YOUR USER ACCOUNT. PLEASE WAIT",
    "register.E-mail não encontrado": "E-mail not found",
    "register.Digite seu e-mail da plataforma IOK antiga": "Type your e-mail from the former IOK platform",
    "register.Não foi possível recuperar sua conta. Verifique seus dados e tente novamente": "It was not possible to retrieve your account. Verify your data and try again",
    "register.Não foi possível recuperar seus dados. Verifique e tente novamente": "It was not possible to retrieve your data. Verify and try again",
    "register.PROSSEGUIR": "CONTINUE",
    "register.VOCÊ ESTÁ SOLICITANDO ACESSO PARA A ORGANIZAÇÃO:": "YOU ARE REQUESTING ACCESS TO THE ORGANIZATION: ",
    "register.COM O ADMINISTRADOR:": " WITH ADMINISTRATOR: ",
    "register.E-mail já cadastrado na plataforma. Informe um novo e-mail ou acesse a plataforma com o e-mail já cadastrado": "E-mail already registered on the platform. Enter a new e-mail or access the platform with the one already registered",
    "register.Empresa já cadastrada na plataforma. Por favor, informe o nome de uma nova empresa": "Company already registered on the platform. Please, enter a new company's name",
    "register.VOCÊ NÃO RECONHECEU O USUÁRIO {userName} COMO PARTE DA SUA ORGANIZAÇÃO E POR ISSO A CONTA DELE FOI DELETADA.": "YOU DID NOT RECOGNIZE THE USER {userName} AS PART OF YOUR ORGANIZATION AND BECAUSE OF THAT THEIR ACCOUNT WERE DELETED.",
    "register.NÂO FOI POSSÍVEL DELETAR O USÁRIO {userName}. POR GENTILEZA, TENTE NOVAMENTE MAIS TARDE.": "IT WAS NOT POSSIBLE TO DELETE USER {userName}. PLEASE, TRY AGAIN LATER.",
    "register.CONFIRMAR": "CONFIRM",
    "register.Não foi possível fazer o cadastro. Verifique seus dados e tente novamente":
    "It was not possible to register. Verify your data and try again",
    "register.VOCÊ RECEBERÁ UM E-MAIL PARA CONCLUIR SEU CADASTRO E ATIVAR SUA CONTA DE ADMINISTRADOR":
    "YOU WILL RECEIVE AN E-MAIL TO FINISH YOUR REGISTRATION AND ACTIVATE YOUR ADMINISTRATOR ACCOUNT",
    "register.Nome": "Name",
    "register.Informe seu nome": "Enter your name",
    "register.O campo nome é obrigatório": "The name field is required",
    "register.E-mail": "E-mail",
    "register.Informe seu e-mail": "Enter your e-mail",
    "register.E-mail inválido. Por favor, verifique novamente":
    "Invalid e-mail. Please, check",
    "register.Telefone": "Phone number",
    "register.Informe seu telefone": "Enter your phone number",
    "register.Crie sua senha": "Create a password",
    "register.Informe sua senha": "Inform your password",
    "register.O campo senha deve conter no mínimo 6 caracteres":
    "The password field must have at least 6 characters",
    "register.Confirme sua senha": "Confirm password",
    "register.As senhas devem ser iguais": "The password must match",
    "register.CRIAR CONTA": "CREATE ACCOUNT",
    "register.CONTA ATIVADA COM SUCESSO": "ACCOUNT ACTIVATED SUCCESSFULLY",
    "register.ACESSAR": "ACCESS",
    "register.NÃO FOI POSSÍVEL ATIVAR SUA CONTA":
    "IT WAS NOT POSSIBLE TO ACTIVATE YOUR ACCOUNT",
    "register.Digite seu telefone": "Inform your phone number",
    "register.AGUARDE ENQUANTO TRANSFERIMOS SEUS DADOS. ESTE PROCESSO DEVE LEVAR ALGUNS MINUTOS. CASO VOCÊ POSSUA UMA GRANDE QUANTIDADE DE DADOS, A TRANSFERÊNCIA PODE LEVAR ATÉ UMA HORA.": "PLEASE WAIT WHILE WE TRANSFER YOUR DATA. THIS PROCESS SHOULD TAKE A FEW MINUTES. IF YOU HAVE A LARGE AMOUNT OF DATA, THE TRANSFER MAY TAKE UP TO ONE HOUR.",
    "register.DADOS TRANSFERIDOS COM SUCESSO! CLIQUE NO BOTÃO ABAIXO PARA ACESSAR A PLATAFORMA.": "DATA TRANSFERED SUCCESSFULLY! CLICK THE BUTTON BELLOW TO ACCESS THE PLATFORM.",
    "register.EMAIL INVÁLIDO. POR GENTILEZA, VERIFIQUE SE SUA CONTA JÁ FOI ATIVADA.": "INVALID E-MAIL. PLEASE, CHECK IF YOUR ACCOUNT HAS ALREADY BEED ACTIVATED.",
    "register.Ainda não tenho uma organização. Criar": "I do not have an organization yet. Create",
    "register.Informe o ID da organização": "Inform your organization's ID",
    "register.O campo com ID é obrigatório": "The ID field is required",
    "register.O ADMINISTRADOR DA ORGANIZAÇÃO RECEBERÁ UM E-MAIL PARA ATIVAR SUA CONTA. POR GENTILIZA, AGUARDE": "THE ORGANIZATION ADMINISTRATOR WILL RECEIVE AN EMAIL TO ACTIVATE YOUR ACCOUNT. PLEASE WAIT",
    "register.ID informado não corresponde a nenhuma companhia. Verifique e tente novamente": "The informed ID does not match any company. Verify and try again",
    "register.A nova plataforma IOK agora conta com novas formas de acesso - que são referentes ao tipo de organização em que você atua. O responsável pela sua organização deve migrar a conta principal da empresa, se tornando o administrador, enquanto o restante dos funcionários devem se vincular a ela pelo ID fornecido.": "The new IOK platform now has new forms of access - which are related to the type of organization in which you work. The person responsible for your organization must migrate the company's main account, becoming the administrator, while the rest of the employees must link to it using the ID provided.",
    "register.O administrador da minha organização já realizou a migração da conta e temos um ID. Desejo migrar meus dados de usuário.": "My organization's administrator has already migrated the account and we have an ID. I want to migrate my user data.",
    "register.Desejo migrar a conta da minha organização e me tornar o administrador.": "I want to migrate my organization's account and become the administrator.",
    "register.Conta da organização já migrada": "Organization account already migrated",
    "register.Migrar conta da organização": "Migrate organization account",
    "register.VOCÊ POSSUI MUITOS MENUS, NÃO CONSEGUIMOS REALIZAR A IMPORTAÇÃO AUTOMÁTICA. SUA CONTA SERÁ ATIVADA, PORÉM OS MENUS PRECISARÃO SER MIGRADOS MANUALMENTE.": "YOU HAVE MANY MENUS, WE CANNOT PERFORM AUTOMATIC IMPORTATION. YOUR ACCOUNT WILL BE ACTIVATED, BUT MENUS WILL NEED TO BE MIGRATED MANUALLY.",
    "register.PARA MIGRAR SEUS MENUS, APÓS O LOGIN, CLIQUE NO SEU NOME NO CANTO SUPERIOR DIREITO, CLIQUE EM EDITAR CONTA E DEPOIS EM IMPORTAR MENUS.": "TO MIGRATE YOUR MENUS, AFTER LOGIN, CLICK ON YOUR NAME IN THE TOP RIGHT CORNER, CLICK ON EDIT ACCOUNT AND THEN ON IMPORT MENUS.",
    "register.Atenção:": "Attention:",
    "register.apenas uma pessoa da organização pode criar a conta e, depois de ativá-la, convidar os demais usuários da empresa para acessá-la.": "only one person from the organization can create the account and, after activating it, invite other users from the company to access it.",
    "register.TOKEN DESENVOLVEDOR CANCELADO": "DEVELOPER TOKEN CANCELED",
    "register.Sua senha deve estar entre 8 e 20 caracteres, ter uma letra maiúscula, uma minúscula, um número e um caractere especial": "Your password must be between 8 and 20 characters, contain one uppercase letter, one lowercase letter, one number, and one special character",
    
    //HOME
    "home.Menus disponíveis na plataforma": "Menus available on the platform",
    "home.Criados na plataforma": "Created on the platform",
    "home.Recebidos dos fornos": "Received from the ovens",
    "home.Equipamentos vinculados": "Linked equipment",
    "home.Total de receitas cadastradas": "Total registered recipes",
    "home.Receitas": "Recipes",
    "home.Receitas em menus": "Recipes in menus",
    "home.Em menus": "In menus",
    "home.Receitas salvas no Cookbook": "Recipes saved in the Cookbook",
    "home.No Cookbook": "In the Cookbook",
    "home.Atualizações": "Updates",
    "home.Copa": "Copa",
    "home.Rocket": "Rocket",
    "home.Single Mag": "Single Mag",
    "home.Versão instalada": "Installed version",
    "home.Versão disponível": "Available version",
    "home.Usuários cadastrados": "Registered users",
    "home.Aceitação pendente": "Pending acceptance",
    "home.Atualizado": "Updated",
    "home.OLÁ": "HELLO",
    "home.É muito bom ter você aqui!": "It's great to have you here!",
    "home.Com a Plataforma IOK é possível administrar seus fornos de onde estiver, criar e gerenciar receitas e menus, fazer backups, analisar os dados de seus equipamentos e muito mais!": "With the IOK Platform you can manage your ovens from wherever you are, create and manage recipes and menus, make backups, analyze data from your equipment and much more!",
    "home.Conheça a plataforma": "Discover the platform",
    "home.Taxa de erro por modelo": "Error rate per model",
    "home.Erro": "Error",
    "home.Modelos em evidência": "Featured models",
    "home.Modelos": "Models",
    "home.Total de equipamentos vinculados": "Total linked equipment",
    "home.Total de equipamentos online": "Total online equipment",
    "home.Equipamentos online": "Online Equipment",
    "home.Países com Prática": "Countries with Prática",
    "home.Países": "Countries",
    "home.Aguarde enquanto carregamos os dados": "Please wait while we load the data",
    "home.Quase lá! Aguarde um pouco mais": "Almost there! Please wait a little longer",
    "home.QUEREMOS SABER SUA OPINIÃO SOBRE": "WE WANT TO KNOW YOUR OPINION ABOUT",
    "home.Valorizamos muito seu ponto de vista e, por isso, este formulário de pesquisa de satisfação sobre a Plataforma {model} foi criado!": "We greatly value your point of view and, therefore, this satisfaction survey form on the {model} Platform was created!",
    "home.Valorizamos muito seu ponto de vista e, por isso, este formulário de pesquisa de satisfação sobre a linha {model} foi criado!": "We greatly value your point of view and, therefore, this satisfaction survey form about the {model} line was created!",
    "home.Suas respostas nos ajudarão a aprimorar nossos serviços, garantindo que continuemos a oferecer a você a melhor experiência possível.": "Your responses will help us improve our services, ensuring we continue to provide you with the best experience possible.",
    "home.Reserve uns minutinhos de seu dia e participe!": "Take a few minutes out of your day and participate!",
    "home.Responder a pesquisa": "Answer the survey",
    "home.Vendas por Equipamento": "Sales by Equipment",
    "home.Total de equipamentos vendidos": "Total Equipment Sold",
    "home.Equipamentos vendidos": "Equipment Sold",
    "home.Clique para atualizar o software": "Click to update the software",
    "home.Aceitação de software pendente": "Software acceptance pending",
    "home.Software atualizado": "Software updated",
    "home.NENHUM EQUIPAMENTO VINCULADO": "NO LINKED EQUIPMENT",
    "home.FORNOS LIGADOS": "OVENS ON",
    "home.Enviando dados": "Sending data",
    "home.Sem envio de dados": "No data transmission",
    "home.Criados na Plataforma": "Created on the Platform",
    "home.Apenas no Cookbook": "Only in the Cookbook",
    "home.Usuários na companhia": "Users in the company",
    "home.Inativos": "Inactive",
    "home.Online": "Online",
    "home.Atualizações de equipamentos": "Equipment updates",
    "home.Modelos de equipamentos": "Equipment models",
    "home.Atualizados": "Updated",
    "home.Aguardando Aceite": "Pending Acceptance",
    "home.Desatualizados": "Not Updated",
    "home.Versão": "Version",
    "home.Recente": "Latest",
    "home.Legenda": "Label",
    "home.Chat": "Chat",
    
    //MAIN
    "main.HOME": "HOME",
    "main.COOKBOOK": "COOKBOOK",
    "main.MEUS MENUS": "MY MENUS",
    "main.EQUIPAMENTOS": "EQUIPMENT",
    "main.USUÁRIOS": "USERS",
    "main.ATENDIMENTOS": "SERVICES",
    "main.Idioma": "Language",
    "main.Editar conta": "Edit account",
    "main.Configurações": "Settings",
    "main.Configurações salvas com sucesso!": "Settings saved successfully!",
    "main.SALVAR": "SAVE",
    "main.CONFIGURAÇÕES": "SETTINGS",
    "main.Tema dark": "Dark theme",
    "main.Notificações": "Notifications",
    "main.Informações para as receitas": "Recipe information",
    "main.Peso:": "Weight:",
    "main.Gramas": "Grams",
    "main.Oz": "Oz",
    "main.Temperatura:": "Temperature:",
    "main.Fahrenheit (°F)": "Fahrenheit (°F)",
    "main.Conta editada com sucesso!": "Account edited successfully!",
    "main.EDITAR CONTA": "EDIT ACCOUNT",
    "main.Nome": "Name",
    "main.Preencha com o seu nome": "Type your name",
    "main.Telefone": "Phone number",
    "main.Preencha com o seu telefone": "Type your phone number",
    "main.E-mail": "E-mail",
    "main.Preencha com o seu e-mail": "Type your e-mail",
    "main.Alterar Senha": "Change Password",
    "main.ALTERAR SENHA": "CHANGE PASSWORD",
    "main.Senha atual": "Current password",
    "main.Nova senha": "New password",
    "main.Confirmar nova senha": "Confirm new password",
    "main.Informe sua senha atual": "Inform your current password",
    "main.O campo senha deve conter no mínimo 6 caracteres":
    "The password field must have at least 6 characters",
    "main.Informe sua nova senha": "Inform your new password",
    "main.Confirme sua nova senha": "Confirm your new password",
    "main.Sua nova senha deve conter no mínimo 6 caracteres":
    "Your new password must contain at least 6 characters",
    "main.INFORME SUA SENHA": "INFORM YOUR PASSWORD",
    "main.Informe sua senha para realizar a alteração de e-mail da plataforma:":
    "Enter your password to change your platform email:",
    "main.CONFIRMAR": "CONFIRM",
    "main.Existem campos que não foram preenchidos corretamente":
    "There are fields that were not filled out correctly",
    "main.Informe sua senha para prosseguir com a alteração de e-mail":
    "Enter your password to proceed with changing your e-mail",
    "main.Senha alterada com sucesso": "Password changed successfully",
    "main.Informe sua senha atual corretamente": "Enter your current password correctly",
    "main.As senhas devem ser iguais": "The password must match",
    "main.Nome do novo tipo de usuário": "New user type name",
    "main.Dê um nome para o novo tipo de usuário": "Give a name to the new user type",
    "main.Token Desenvolvedor": "Developer Token",
    "main.O Token Desenvolvedor é um código único e intransferível que permite a realização de alterações": "The Developer Token is a unique and non-transferable code that allows changes at the development level directly in the platform's code through external APIs. They enable customization of the platform to better meet your company's needs.",
    "main.É recomendado que estas alterações sejam realizadas por um profissional da área de tecnologia": "It is recommended that these changes be made by a professional in the technology field.",
    "main.Para acessar o token, informe sua senha": "To access the token, please provide your password.",
    "main.Copie e cole o token na autenticação de todas as requisições.": "Copy and paste the token into the authentication of all requests.",
    "main.Seu Token": "Your token",
    "main.Token copiado com sucesso!": "Token copied successfully!",
    "main.Você deseja cancelar o preenchimento das informações?": "Do you want to cancel filling out the information?",
    "main.Rever tutoriais": "Review tutorials",
    "main.Tutoriais resetados com sucesso!": "Tutorials successfully reset!",
    "main.review.tutorials": "Do you want to review the tutorials on the IOK platform?",
    "main.Procurar": "Search",
    "main.review.manual": "It is also possible to save it on your computer.",
    "main.review.download": "Access manual",
    
    //MENUS
    "menus.Procurar menu": "Search menu or user",
    "menus.Procurar menu excluído": "Search deleted menu",
    "menus.Menus": "Menus",
    "menus.Lixeira": "Trash",
    "menus.CRIAR MENU": "CREATE MENU",
    "menus.IMPORTAR MENU": "IMPORT MENU",
    "menus.Os arquivos serão mantidos na lixeira por 30 dias a contar de sua data de exclusão. Após este período, eles serão excluídos definitivamente.":
    "The files will be kept in trash for 30 days from the date of deletion. After this period, they will be deleted definitely.",
    "menus.VOLTAR": "return",
    "menus.Compatível com: ": "Compatible with: ",
    "menus.Última atualização: ": "Last update: ",
    "menus.Última atualização": "Last update",
    "menus.EXPORTAR MENU": "EXPORT MENU",
    "menus.EDITAR MENU": "EDIT MENU",
    "menus.Equipamentos associados": "Associated equipment",
    "menus.Grupos": "Groups",
    "menus.Procurar grupo": "Search group",
    "menus.CRIAR GRUPO": "CREATE GROUP",
    "menus.receitas": "recipes",
    "menus.Nenhum grupo cadastrado": "No groups registered",
    "menus.Nenhum menu cadastrado": "No menus registered",
    "menus.Nome": "Name",
    "menus.Modelo": "Model",
    "menus.Atividade": "Activity",
    "menus.Associação": "Association",
    "menus.Exportar": "Export",
    "menus.Editar": "Edit",
    "menus.Excluir": "Delete",
    "menus.Equips": "Equip",
    "menus.Receitas": "Recipes",
    "menus.Compatibilidade": "Compatibility",
    "menus.Versão": "Version",
    "menus.Origem": "Origin",
    "menus.Excluído por": "Deleted by",
    "menus.Data de exclusão": "Deletion date",
    "menus.Restaurar": "Restore",
    "menus.Existem campos que não foram preenchidos":
    "There are fields that have not been filled",
    "menus.Menu criado com sucesso!": "Menu created successfully!",
    "menus.Existem campos com informações inválidas":
    "There are fields with invalid information",
    "menus.SALVAR": "SAVE",
    "menus.CANCELAR": "CANCEL",
    "menus.Nome do menu": "Menu's name",
    "menus.Informe o nome do menu": "Inform menu's name",
    "menus.Preencha o nome do menu sem caracteres especiais": "Fill the menu's name with no special characters",
    "menus.Selecionar": "Select",
    "menus.Idioma": "Language",
    "menus.Temperatura de pré-aquec 1": "Pre heating temperature 1",
    "menus.Informe a temperatura de pré-aquec 1":
    "Inform pre heating temperature 1",
    "menus.Temperatura de pré-aquec 2": "Pre heating temperature 2",
    "menus.Informe a temperatura de pré-aquec 2":
    "Inform pre heating temperature 2",
    "menus.Tempo para estabilização": "Stabilization time",
    "menus.Informe o tempo para estabilização":
    "Inform stabilization time",
    "menus.Desativar pré-aquec 2": "Deactivate pre heating 2",
    "menus.Configurações de data e hora": "Date and time settings",
    "menus.Data:": "Date:",
    "menus.DD/MM/AAAA": "DD/MM/YYYY",
    "menus.Hora:": "Times:",
    "menus.24h": "24h",
    "menus.AM/PM": "AM/PM",
    "menus.EUR: DD/MM/AAAA": "EUR: DD/MM/YYYY",
    "menus.USA: MM/DD/AAAA": "USA: MM/DD/YYYY",
    "menus.ISO: AAAA/MM/DD": "ISO: YYYY/MM/DD",
    "menus.Seleção de acessos para habilitar":
    "Selection of access to enable",
    "menus.Modo manual": "Manual mode",
    "menus.Habilitado": "Able",
    "menus.Desabilitado": "Disabled",
    "menus.Favoritos": "Favorites",
    "menus.Aquecer/Dourar": "Heat/Brown",
    "menus.Repetir receita": "Repeat recipe",
    "menus.Configurações gerais do menu": "Menu's general settings",
    "menus.Temperatura:": "Temperature:",
    "menus.Fahrenheit (°F)": "Fahrenheit (°F)",
    "menus.Gramas": "Grams",
    "menus.Oz": "Oz",
    "menus.Tema:": "Theme:",
    "menus.Dark": "Dark",
    "menus.Light": "Light",
    "menus.Introdução:": "Introduction:",
    "menus.Ativada": "Activated",
    "menus.Desativada": "Deactivated",
    "menus.Menu deletado com sucesso!": "Menu deleted successfully!",
    "menus.Não foi possivel deletar o menu": "Unable to delete menu",
    "menus.Sim": "Yes",
    "menus.Não": "No",
    "menus.Excluir definitivamente": "Permanently delete",
    "menus.SALVAR NO DISPOSITIVO": "SAVE TO DEVICE",
    "menus.EXPORTAR": "EXPORT",
    "menus.Selecione os modelos e versões dos equipamentos que receberão o menu.":
    "Select the equipment models and versions to receive the menu.",
    "menus.Forno": "Oven",
    "menus.Fundo verde": "Green background",
    "menus.Fundo preto": "Black background",
    "menus.Linux": "Linux",
    "menus.Atenção: antes de transferir o menu de seu pen drive para o equipamento, é necessário descompactar o arquivo, exceto para menus de equipamentos Linux.":
    "Attention: before transfering the menu from your  flash drive to the equipment, it is necessary to unzip the file, except for Linux equipment's menus.",
    "menus.Selecione os equipamentos para os quais deseja exportar o menu.":
    "Select the equipment for which you want to export the menu.",
    "menus.Nome do equipamento": "Equipment's name",
    "menus.Selecionar todos": "Select all",
    "menus.Selecionar todas": "Select all",
    "menus.Categoria: ": "Category: ",
    "menus.Você deseja excluir o menu?": "Do you wish to delete the menu?",
    "menus.O menu será deletado da plataforma, mas permanecerá no equipamento. Uma cópia de segurança será criada automaticamente e ficará disponível por 30 dias em Meus Menus - Lixeira.":
    "The menu will be deleted from the platform, but will be kept in the equipment. A safety copy will be created automatically and will be available for 30 days in My Menus - Trash.",
    "menus.Você deseja excluir o arquivo definitivamente?":
    "Do you wish to delete the file permanently?",
    "menus.Esta ação não poderá ser desfeita.":
    "This action cannot be undone.",
    "menus.Menu editado com sucesso!": "Menu edited successfully!",
    "menus.IMPORTAR": "IMPORT",
    "menus.VERIFICAÇÃO DE VERSÃO": "VERSION VERIFICATION",
    "menus.Para conferir a versão da placa de seu equipamento, siga os seguintes passos:":
    "To check the equipment's board version, follow the following steps:",
    "menus.No forno, acesse Configurações;": "In the oven, access Settings;",
    "menus.Insira a senha 456789;": "Enter password 456789;",
    "menus.Selecione a opção Sistema;": "Select option System;",
    "menus.Selecione Informações do Fabricante;":
    "Select Manufacturer Information;",
    "menus.O modelo de sua placa estará na linha Firmware IHM;":
    "Your board's model will be in line Firmware IHM;",
    "menus.1ª geração A": "1st generation A",
    "menus.Firmware IHM: 12.3.4": "Firmware IHM: 12.3.4",
    "menus.1ª geração B": "1st generation B",
    "menus.2ª geração/Linux:": "2nd generation/Linux:",
    "menus.Firmware IHM: L1.2.3": "Firmware IHM: L1.2.3",
    "menus.Selecione o modelo/versão do equipamento do qual deseja importar o menu. Saiba como conferir a versão de seu equipamento":
    "Select the equipment's model/version from which you wish to import the menu. Know how to check your equipment's version ",
    "menus.Selecione o modelo/versão do equipamento": "Select the equipment model/version",
    "menus.Como verificar a versão da placa":
    "How to check the board's version",
    "menus.1° Geração": "1st generation",
    "menus.Menu restaurado com sucesso!": "Menu restored successfully!",
    "menus.Não foi possivel restaurar o menu":
    "Unable to restore menu",
    "menus.RESTAURAR ARQUIVO": "RESTORE FILE",
    "menus.Você deseja restaurar o arquivo?":
    "Do you wish to restore file?",
    "menus.O arquivo será restaurado como uma nova versão na plataforma, na guia Todos. Para salvá-lo no equipamento, exporte-o.":
    "The file will be restored as a new version on the platform under the All tab. To save it on your device, export it.",
    "menus.EXCLUIR MENU": "DELETE MENU",
    "menus.Nenhum equipamento associado": "No associated equipment",
    "menus.Nomeie o novo menu": "Name the new menu",
    "menus.Nomeie o novo grupo": "Name the new group",
    "menus.Nome do grupo": "Group's name",
    "menus.Preencha o nome do grupo sem caracteres especiais":
    "Fill the group's name with no special characters",
    "menus.Pré-aquecimento:": "Pre heating:",
    "menus.Grupo criado com sucesso!": "Group created successfully!",
    "menus.SELECIONE UMA IMAGEM": "SELECT AN IMAGE",
    "menus.SELECIONAR": "SELECT",
    "menus.Selecionar do dispositivo": "Select from device",
    "menus.Selecionar do banco de imagens": "Select from image bank",
    "menus.Formato .JPG ou .PNG": ".JPG or .PNG format",
    "menus.Procurar imagem": "Search image",
    "menus.Pertence ao menu": "Belongs to menu",
    "menus.Alterar imagem": "Change image",
    "menus.Remover imagem": "Remove image",
    "menus.EDITAR GRUPO": "EDIT GROUP",
    "menus.Nome:": "Name:",
    "menus.CRIAR RECEITA": "CREATE RECIPE",
    "menus.SALVAR DO COOKBOOK": "SAVE FROM COOKBOOK",
    "menus.Procurar receita do grupo": "Search group's recipe",
    "menus.Ingrediente principal": "Main ingredient",
    "menus.Limpar filtros": "Clear filters",
    "menus.Filtrar": "Filter",
    "menus.Mover receitas": "Move recipes",
    "menus.Excluir receitas": "Delete recipes",
    "menus.Editar grupo": "Edit group",
    "menus.Excluir grupo": "Delete group",
    "menus.aqui": "here",
    "menus.Se o código possuir apenas números e o fundo da tela for verde, pertence à 1ª A, se possuir apenas números e o fundo da tela for preta, pertence à 1ª B e, se começar com as letras L, F ou S, sua placa pertence à 2ª geração/Linux.":
    "If the code has only numbers and the background is green, it belong to 1st A, if it has only numbers and the background is black, it belongs to 1st B and, if it starts with letters L, F or S, its board belongs to 2nd generation/Linux.",
    "menus.1ª A - Fundo verde": "1st A - Green background",
    "menus.1ª B - Fundo preto": "1st B - Black background",
    "menus.2ª - Linux": "2nd - Linux",
    "menus.Tivemos um problema. Tente novamente mais tarde.":
    "We have had a problem. Try again later.",
    "menus.Grupo editado com sucesso!": "Group edited successfully!",
    "menus.AINDA NÃO HÁ GRUPOS AQUI :(": "THERE ARE STILL NO GROUPS HERE :(",
    "menus.description.AINDA NÃO HÁ GRUPOS AQUI :(": "Click the button located in the upper right corner and add groups.",
    "menus.NENHUM MENU NA LIXEIRA": "NO MENU IN TRASH",
    "menus.AINDA NÃO HÁ MENUS AQUI :(": "THERE ARE STILL NO MENUS HERE :(",
    "menus.description.AINDA NÃO HÁ MENUS AQUI :(": "Click one of the buttons located in the top right corner and add menus.",
    "menus.Adicionar imagem": "Add image",
    "menus.Nome da receita": "Recipe's name",
    "menus.Detalhes da receita": "Recipe's details",
    "menus.Programação da receita": "Recipe's programming",
    "menus.Nomeie sua receita": "Name your recipe",
    "menus.Preencha o nome da receita sem caracteres especiais": "Fill the recipe's name with no special characters",
    "menus.Apenas os caracteres @#%&*-+()!\"<>:;\\/?. são permitidos": "Only the characters @#%&*-+()!\"<>:;\/?. are allowed",
    "menus.Tipo de prato": "Type of meal",
    "menus.SALVAR RECEITAS DO COOKBOOK": "SAVE RECIPES FROM COOKBOOK",
    "menus.Selecione as receitas que deseja salvar no grupo de seu menu:":
    "Select the recipes you wish to save in your menu group:",
    "menus.Procurar receita": "Search recipe",
    "menus.deleteGroupSuccess":
    "{count, plural, one {Group deleted successfully!} other {Groups deleted successfully!}}",
    "menus.deleteGroupError":
    "{count, plural, one {Unable to delete group} other {Unable to delete groups}}",
    "menus.EXCLUIR GRUPO": "DELETE GROUP",
    "menus.confirmDeleteGroupMessage":
    "{count, plural, one {Do you wish to delete the group permanently?} other {Do you wish to delete the groups permanently?}}",
    "menus.AINDA NÃO HÁ RECEITAS AQUI :(": "THERE ARE STILL NO RECIPES HERE :(",
    "menus.description.AINDA NÃO HÁ RECEITAS AQUI :(": "Click one of the buttons located in the top right corner and add recipes.",
    "menus.Temp. de entrada": "Starting temp",
    "menus.Temp. de pré-aquec": "Pre heating temperature",
    "menus.Ingredientes para montagem": "Ingredients for assembly",
    "menus.Instruções operacionais": "Operating instructions",
    "menus.Passo": "Step",
    "menus.Temp": "Temp ",
    "menus.Temp.": "Temp. ",
    "menus.Tempo": "Time",
    "menus.Velocidade do ar": "Air speed",
    "menus.Micro-ondas": "Microwave",
    "menus.Resistência inferior": "Lower resistance",
    "menus.Informações": "Information",
    "menus.Digite as informações do passo": "Type the step information",
    "menus.desativar": "deactivate",
    "menus.Ingredientes": "Ingredients",
    "menus.Temperatura de entrada": "Starting temperature",
    "menus.Equipamentos compatíveis": "Compatible equipment",
    "menus.Tempo total": "Total time",
    "menus.SALVAR NO COOKBOOK": "SAVE TO COOKBOOK",
    "menus.ver localização": "see location",
    "menus.SELECIONE RECEITAS PARA EXCLUIR": "SELECT RECIPES TO DELETE",
    "menus.Você deseja excluir as receitas selecionadas definitivamente?":
    "Do you wish to delete the selected recipes definitely?",
    "menus.Receitas deletadas com sucesso!": "Recipes deleted successfully!",
    "menus.Informe aqui os ingredientes para montagem":
    "Inform here the ingredientes for assembly",
    "menus.Informe aqui as instruções operacionais":
    "Inform here the operating instructions",
    "menus.Adicionar passo": "Add step",
    "menus.Receita criada com sucesso!": "Recipe created successfully!",
    "menus.Ideal para:": "Ideal for: ",
    "menus.editar detalhes": "edit details",
    "menus.excluir": "delete",
    "menus.editar": "edit",
    "menus.Receita editada com sucesso!": "Recipe edited successfully!",
    "menus.Passo deletado com sucesso!": "Step deleted sucessfully!",
    "menus.Não foi possivel deletar o passo":
    "Unable to delete step",
    "menus.EXCLUIR PASSO": "DELETE STEP",
    "menus.Você deseja excluir este passo?": "Do you wish to delete this step?",
    "menus.Esta ação não poderá ser desfeita. Caso prefira, é possível apenas desativá-lo, mantendo assim sua configuração.":
    "This action cannot be undone. If you prefer, it is possible to only deactivate it, keeping its settings. ",
    "menus.Peso": "Weight",
    "menus.Origem da receita": "Recipe's origin",
    "menus.Pré-aquecimento": "Pre heating",
    "menus.Plataforma": "Platform",
    "menus.Receita salva com sucesso!": "Recipe saved successfully!",
    "menus.Exportar receitas": "Export recipes",
    "menus.expandir": "expand",
    "menus.Temperatura": "Temperature",
    "menus.Vapor combinado": "Combined steam",
    "menus.Ar quente": "Hot air",
    "menus.Sonda": "Probe",
    "menus.Tempo (min)": "Time (min)",
    "menus.Umidade (%)": "Humidity (%)",
    "menus.Injeção de vapor": "Steam injection",
    "menus.Dumper aberto": "Open dumper",
    "menus.Informe o peso": "Inform the weight",
    "menus.Informe a temperatura de entrada":
    "Inform the starting temperature",
    "menus.Informe os ingredientes para montagem":
    "Enter the ingredients for assembly",
    "menus.Informe as instruções operacionais":
    "Enter the operating instructions",
    "menus.Injeção de vapor (seg)": "Steam injection (sec)",
    "menus.Aquecer mais": "Heat more",
    "menus.Dourar mais": "Brown more",
    "menus.Aquecer e dourar mais": "Heat and brown more",
    "menus.Favoritar receita": "Favorite recipe",
    "menus.Apenas favoritos": "Only favorites",
    "menus.Forno combinado": "Combined oven",
    "menus.Cocção múltipla": "Multiple cooking",
    "menus.Receitas Technicook": "Technicook Recipes",
    "menus.Editar grupos": "Edit groups",
    "menus.Informe a data": "Enter date",
    "menus.Informe a hora": "Enter time",
    "menus.até 300": "up to 300",
    "menus.Vapor": "Vapor",
    "menus.Turbina": "Turbine",
    "menus.Criar grupo": "Create group",
    "menus.MOVER": "MOVE",
    "menus.Configurações de data e hora:": "Date and time settings:",
    "menus.Configurações de acessos:": "Access settings:",
    "menus.SELECIONE RECEITAS PARA MOVER": "SELECT RECIPES TO MOVE",
    "menus.AVANÇAR": "ADVANCE",
    "menus.Selecione ou crie um grupo no mesmo menu para mover as receitas selecionadas ou as mova para outro menu. Note que apenas os menus/grupos compatíveis com as predefinições das receitas serão exibidos.":
    "Select or create a group in the same menu to move selected recipes or move them to another menu. Note that only the menus/groups that are compatible with the recipe's presets will be displayed.",
    "menus.Mover receitas para o mesmo menu": "Move recipes to the same menu",
    "menus.Mover receitas para outro menu": "Move recipes to another menu",
    "menus.Selecionar grupo": "Select group",
    "menus.Nenhuma receita foi selecionada": "No recipe was selected",
    "menus.Passo editado com sucesso!": "Step edited successfully!",
    "menus.Menu atualizado": "Menu updated",
    "menus.até 260": "up to 260",
    "menus.Umidade na câmara": "Chamber humidity",
    "menus.Passos": "Steps",
    "menus.ativar": "activate",
    "menus.Informe a temperatura de pré-aquec": "Enter the pre heating temperature",
    "menus.Movas as receitas selecionadas para outro menu. Note que apenas os menus compatíveis com as predefinições das receitas serão exibidos.":
    "Move selected recipes to another menu. Note that only the menus that are compatible with the recipe's presets will be displayed.",
    "menus.Sonda (°C)": "Probe (ºC)",
    "menus.Turbo Grill": "Turbo Grill",
    "menus.Pré-aquecimento padrão, conforme passo 1": "Standard pre heating, as per step 1",
    "menus.salvar": "save",
    "menus.até": "up to",
    "menus.Verificação de receita": "Recipe's check",
    "menus.Auto import": "Auto import",
    "menus.Atualização forçada": "Forced update",
    "menus.Lista de receitas exportada com sucesso!": "Recipes list exported successfully!",
    "menus.Receita movida com sucesso!": "Recipe moved successfully!",
    "menus.Receitas movidas com sucesso!": "Recipes moved successfully!",
    "menus.+ Menu": "+ Menu",
    "menus.+ Receita": "+ Recipe",
    "menus.Escolha um idioma compatível com o equipamento": "Select a language compatible with the equipment",
    "menus.Dourar": "Brown",
    "menus.Não atribuir a menu": "Do not assign to menu",
    "menus.Todos": "All",
    "menus.Meus menus": "My menus",
    "menus.Para salvar uma receita, preencha todos os campos": "To save a recipe, fill in all fields",
    "menus.Selecione os grupos de equipamentos para os quais deseja exportar o menu.": "Select the equipment groups for which you want to export the menu.",
    "menus.MENU IMPORTADO COM SUCESSO!": "MENU IMPORTED SUCCESSFULLY!",
    "menus.Formato inválido. São permitidos apenas os formatos .jpeg e .png": "Invalid format. Only formats .jpeg and .png are allowed.",
    "menus.Reordenar grupos": "Reorder groups",
    "menus.O que deseja fazer?": "What would you like to do?",
    "menus.Reordenar receitas": "Reorder recipes",
    "menus.ITENS REORDENADOS COM SUCESSO! PARA APLICAR AS ALTERAÇÕES NO FORNO, EXPORTE O MENU.": "ITEMS REORDERED SUCCESSFULLY! TO APPLY CHANGES TO THE OVEN, EXPORT THE MENU.",
    "menus.ARRASTE OS ITENS PARA O LOCAL DESEJADO": "Drag the items to the desired location.",
    "menus.Dumper": "Dumper",
    "menus.Aberto": "Open",
    "menus.Fechado": "Closed",
    "menus.Intermitente": "Intermittent",
    "menus.Se o seu menu incluir itens sensíveis à uniformidade, recomendamos definir o Tempo de Estabilização entre 3:00 e 5:00 minutos. Caso contrário, você pode deixá-lo em 5 segundos.": "If your menu includes items that are sensitive to uniformity, we recommend setting the Stabilization Time between 3:00 and 5:00 minutes. Otherwise, you can leave it at 5 seconds.",
    "menus.Selecione o menu que deseja exportar:": "Select the menu you want to export:",
    "menus.Temperatura de pré-aquecimento": "Preheating temperature",
    "menus.Temperatura de lastro": "Ballast temperature",
    "menus.Temperatura de teto": "Ceiling temperature",
    "menus.Volume de injeção de vapor (ml)": "Steam injection volume (ml)",
    "menus.Parada de turbina": "Turbine stop",
    "menus.Alta": "High",
    "menus.Média": "Medium",
    "menus.Baixa": "Low",
    "menus.a": "the",
    "menus.Valor da injeção": "Injection value",
    "menus.Volume: até 999ml": "Volume: up to 999ml",
    "menus.Tempo: até 15 segundos": "Time: up to 15 seconds",
    "menus.Tempo de injeção de vapor (seg)": "Steam injection time (sec)",
    "menus.Atenção!": "Attention!",
    "menus.Verifique as receitas do menu e ajuste os valores da Injeção de Vapor após alterar sua unidade de medida.": "Check menu recipes and adjust Steam Injection values ​​after changing your unit of measurement.",
    "menus.Certifique-se de que a unidade de temperatura (°C ou °F) definida no equipamento seja a mesma que foi selecionada na criação do menu:": "Make sure that the temperature unit (°C or °F) defined on the equipment is the same as that selected when creating the menu:",
    "menus.Injeção desativada": "Injection disabled",
    "menus.Selecione a unidade de temperatura que está definida no equipamento:": "Select the temperature unit that is defined on the equipment:",
    "menus.Clique para atualizar": "Click to update",
    "menus.A função Atualização Forçada envia automaticamente o menu para os equipamentos selecionados, e que possuam versão compatível com este tipo de atualização, na próxima vez em que forem ligados. Os fornos que não estiverem atualizados ainda precisarão realizar o aceite manual.": "The Forced Update function automatically sends the menu to selected equipment, which has a version compatible with this type of update, the next time it is turned on. Equipment that are not updated will still need to undergo manual acceptance.",
    "menus.As opções selecionadas estarão disponíveis nos equipamentos que receberem este menu, podendo ser utilizadas pelo operador. É possível alterar estas configurações posteriormente no próprio forno ou pela plataforma.": "The selected options will be available on equipment that receives this menu and can be used by the operator. It is possible to change these settings later in the oven itself or via the platform.",
    "menus.Não foi possivel deletar as receitas": "Unable to delete recipes",
    "menus.PRÉ": "PRE",
    "menus.Speed Ovens": "Speed Ovens",
    "menus.Fornos Combinados": "Combi Ovens",
    "menus.Fornos de Panificação": "Baking Ovens",
    "menus.Após a criação, o tipo do menu não pode ser alterado. Ele só pode ser definido no momento da criação.": "After creation, the menu type cannot be changed. It can only be set at the time of creation.",
    "menus.Pré-aquecimento do grupo": "Group Preheating",
    "menus.Atenção: antes de transferir o menu de seu pen drive para o equipamento, é necessário descompactar o arquivo, transferindo a pasta PRATICA para o equipamento.": "Attention: before transferring the menu from your USB drive to the equipment, you must unzip the file, transferring the PRATICA folder to the equipment.",
    "menus.Tamanho máximo": "Maximum size",
    "menus.Possibilita que o operador do forno crie parâmetros e os execute em seguida.": "Allows the oven operator to create parameters and execute them afterward.",
    "menus.Acesso também à execução das receitas favoritas.": "Also provides access to the preparation of favorite recipes.",
    "menus.Possibilita que o operador adicione mais tempo para aquecer/dourar a refeição depois de sua execução.": "Allows the operator to add more time to heat/brown the meal after preparation.",
    "menus.Possibilita a repetição da receita assim que sua execução é finalizada.": "Allows the recipe to be repeated as soon as its preparation is completed.",
    "menus.Acesso exclusivo às receitas favoritas.": "Exclusive access to favorite recipes.",
    "menus.Habilita o lembrete para o operador conferir se o alimento já está dentro do forno.": "Enables the reminder for the operator to check if the food is already inside the oven.",
    "menus.O forno importa automaticamente, ao ligar, um menu que esteja salvo em pen drive e nele inserido.": "The oven automatically imports a menu saved on a USB drive when turned on.",
    "menus.Possibilita a cocção de diversos alimentos simultaneamente, um em cada GN.": "Allows the simultaneous cooking of various foods, one in each GN.",
    "menus.Permite a execução de receitas pré programadas, vindas de fábrica.": "Allows the preparation of pre-programmed recipes from the factory.",
    "menus.Permite acesso à função turbo grill, que atinge até 300°C.": "Allows access to the turbo grill function, which reaches up to 300°C.",
    "menus.Possibilita que o operador adicione mais tempo para dourar a refeição depois de sua execução.": "Allows the operator to add extra time to brown the meal after its preparation.",
    "menus.Permite que o operador edite grupos de receitas diretamente da tela inicial.": "Allows the operator to edit recipe groups directly from the home screen.",
    "menus.Copiar grupos": "Copy groups",
    "menus.Excluir grupos": "Delete groups",
    "menus.Copiar": "Copy",
    "menus.Selecione grupos para copiar": "Select groups to copy",
    "menus.Selecione o destino dos grupos": "Select the destination for the groups",
    "menus.Colar": "Paste",
    "menus.Deseja cancelar a cópia e envio de grupos para os menus?": "Do you want to cancel the copying and sending of groups to the menus?",
    "menus.Grupos colados com sucesso": "{count, plural, one {Group pasted successfully!} other {Groups pasted successfully!}}",
    "menus.Copiar receitas": "Copy recipes",
    "menus.Selecione receitas para copiar": "Select recipes to copy",
    "menus.Selecione o destino das receitas": "Select the destination for the recipes",
    "menus.Deseja cancelar a cópia e envio de receitas para os grupos?": "Do you want to cancel the copying and sending of recipes to the groups?",
    "menus.Receitas coladas com sucesso": "{count, plural, one {Recipe pasted successfully!} other {Recipes pasted successfully!}}",
    "menus.Converter para C-MAX EVO": "Convert to C-MAX EVO",
    "menus.Uma cópia deste menu, adaptada para o C-MAX EVO, será criada. Recomendamos que revise cuidadosamente todos os parâmetros dos passos e atualize as receitas com novas imagens, se julgar necessário.": "A copy of this menu, adapted for the C-MAX EVO, will be created. We recommend carefully reviewing all step parameters and updating the recipes with new images if necessary.",
    "menus.Menu convertido com sucesso!": "Menu successfully converted!",
    "menus.Não foi possível converter o menu. Tente novamente mais tarde": "The menu could not be converted. Please try again later.",
    "menus.O menu está sendo convertido... Aguarde!": "The menu is being converted... Please wait!",
    "menus.Menu incompatível com": "Menu incompatible with",
    "menus.Selecione pelo menos um grupo": "Select at least one group",
    "menus.Selecione pelo menos um menu": "Select at least one menu",
    "menus.Menu atual": "Current menu",
    "menus.Copiando grupos": "{count, plural, one {The group is being copied... Please wait!} other {The groups are being copied... Please wait!}}",
    "menus.Erro ao copiar grupos": "{count, plural, one {It was not possible to copy the group. Please try again later!} other {It was not possible to copy the groups. Please try again later!}}",
    "menus.Procurar pelo nome do menu": "Search by menu name",
    "menus.Escolha um grupo de destino para cada menu selecionado": "Choose a target group for each selected menu!",
    "menus.Copiando receitas": "{count, plural, one {The recipe is being copied... Please wait!} other {The recipes are being copied... Please wait!}}",
    "menus.Erro ao copiar receitas": "{count, plural, one {Failed to copy the recipe. Please try again later!} other {Failed to copy the recipes. Please try again later!}}",
    "menus.SELECIONE GRUPOS PARA EXCLUIR": "SELECT GROUPS TO DELETE",
    "menus.Padeiro noturno": "Night baker",
    "menus.Permite programar o início (pré-aquecimento) de uma receita específica ou informada manualmente (Modo Manual), sem a necessidade de presença de um operador no local.": "Allows scheduling the start (preheating) of a specific recipe or one manually entered (Manual Mode), without the need for an operator to be present on location.",
    "menus.Vaporizador": "Vaporizer",
    "menus.Editar receitas": "Edit recipes",
    "menus.Permite que o operador edite receitas diretamente da tela inicial.": "Allows the operator to edit recipes directly from the home screen.",
    "menus.Preencha o nome da receita": "Enter the recipe name",
    "menus.Tempo nível": "Time level",
    "menus.Fermentadora": "Proofer",
    "menus.0 ou 5 a 59s": "0 or 5 to 59s",
    "menus.Informe o tempo para aquecer mais":
    "Enter the time to heat more",
    "menus.Informe o tempo para dourar mais":
    "Enter the time to brown more",
    "menus.Informe o tempo para aquecer e dourar mais":
    "Enter the time to heat and brown more",
    "menus.Selecione uma imagem": "Select an image",
    "menus.*Para criar receitas para fornos sem conectividade, crie um menu e então as receitas.": "*To create recipes for ovens without connectivity, first create a menu and then the recipes.",
    "menus.CONVERTER": "CONVERT",
    "menus.Converter para FIT": "Convert to FIT",
    "menus.Converter para outro FIT": "Convert to another FIT",
    "menus.Selecione pelo menos um modelo FIT": "Select at least one FIT model",
    "menus.O menu está sendo convertido para FIT... Aguarde!": "The menu is being converted to FIT... Please wait!",
    "menus.{count} menu(s) convertido(s) com sucesso para FIT!": "{count} menu(s) successfully converted to FIT!",
    "menus.Alguns menus foram convertidos, mas houve falha em: {models}": "Some menus were converted, but there was a failure in: {models}",
    "menus.Uma cópia deste menu será criada para cada modelo FIT selecionado, mantendo configurações, grupos, receitas e passos.": "A copy of this menu will be created for each selected FIT model, preserving configurations, groups, recipes, and steps.",
    "menus.Uma cópia deste menu será criada para cada modelo FIT selecionado, mantendo configurações, grupos, receitas e passos. No entanto, como cada forno possui dimensões e características específicas, recomendamos revisar e ajustar os parâmetros para garantir o melhor desempenho e resultado em cada equipamento. Selecione o modelo da linha FIT para qual deseja converter o menu." : "A copy of this menu will be created for each selected FIT model, preserving configurations, groups, recipes, and steps. However, as each oven has specific dimensions and characteristics, we recommend reviewing and adjusting the parameters to ensure the best performance and results for each piece of equipment. Select the FIT line model to which you want to convert the menu.",
    
    //COOKBOOK
    "cookbook.RECEITAS DISPONÍVEIS": "AVAILABLE RECIPES",
    "cookbook.RECEITAS SALVAS": "SAVED RECIPES",
    "cookbook.ENVIAR PARA MENU": "SEND TO MENU",
    "cookbook.SALVAR": "SAVE",
    "cookbook.salvar": "save",
    "cookbook.Filtrar por": "Filter by",
    "cookbook.Procurar receita do cookbook": "Search recipe from cookbook",
    "cookbook.Equipamento": "Equipment",
    "cookbook.Ingrediente principal": "Main ingredient",
    "cookbook.Tipo de prato": "Type of meal",
    "cookbook.Região": "Region",
    "cookbook.Pré-aquecimento": "Pre heating",
    "cookbook.Procurar receita": "Search recipe",
    "cookbook.Menu": "Menu",
    "cookbook.ENVIAR": "SEND",
    "cookbook.Procurar nome do menu": "Search for menu's name",
    "cookbook.Escolha um grupo deste menu": "Choose a group from this menu",
    "cookbook.Selecionar grupo": "Select group",
    "cookbook.Tivemos um problema. Tente novamente mais tarde":
    "We had a problem. Try again later",
    "cookbook.Receita adicionada com sucesso!": "Recipe added successfully!",
    "cookbook.Não foi possível adicionar a receita. Tente novamente mais tarde":
    "It was not possible to add recipe. Try again later",
    "cookbook.Selecione um menu e um grupo para enviar esta receita":
    "Select a menu and a group to send this recipe",
    "cookbook.Selecione o modelo do equipamento primeiro": "Select the equipment's model first",
    "cookbook.Grupo": "Group",
    "cookbook.Não foi possível salvar os passos da receita": "It was not possible to save the recipe's steps",
    "cookbook.Bovina": "Beef",
    "cookbook.Frango": "Chicken",
    "cookbook.Ovos": "Eggs",
    "cookbook.Pães": "Breads",
    "cookbook.Peixes": "Fish",
    "cookbook.Queijo": "Cheese",
    "cookbook.Suína": "Pork",
    "cookbook.Vegetais": "Vegetables",
    "cookbook.Outros": "Others",
    "cookbook.Entradas/aperitivos": "Starters/appetizers",
    "cookbook.Principais": "Main",
    "cookbook.Snacks": "Snacks",
    "cookbook.Pizzas": "Pizzas",
    "cookbook.Massas": "Pastas",
    "cookbook.Acompanhamentos": "Side dishes",
    "cookbook.Sobremesas": "Desserts",
    "cookbook.Manhã": "Breakfast",
    "cookbook.Padaria": "Bakery",
    "cookbook.Todos": "All",
    "cookbook.Não atribuir origem": "Do not attribute origin",
    "cookbook.Brasil": "Brazil",
    "cookbook.Alemanha": "Germany",
    "cookbook.França": "France",
    "cookbook.Rússia": "Russia",
    "cookbook.China": "China",
    "cookbook.Japão": "Japan",
    "cookbook.Itália": "Italy",
    "cookbook.Egito": "Egypt",
    "cookbook.Grécia": "Greece",
    "cookbook.Argentina": "Argentina",
    "cookbook.África": "Africa",
    "cookbook.Estados Unidos": "United States",
    "cookbook.Coreia": "Korea",
    "cookbook.Turquia": "Turkey",
    "cookbook.Ideal para": "Ideal for",
    "cookbook.Polônia": "Poland",
    "cookbook.Sanduíches": "Sandwiches",
    "cookbook.A receita não foi adicionada ao menu pois não há grupos criados":
    "The recipe was not added to the menu because no groups have been created.",
    "cookbook.Nova Receita": "New Recipe",
    
    //EQUIPAMENTOS
    "equipment.equipamentos": "equipment",
    "equipment.procurar equipamento": "Search for equipment or user",
    "equipment.adicionar equipamento": "add equipment",
    "equipment.atualizar equipamento": "update equipment",
    "equipment.+ equipamentos": "+ equipment",
    "equipment.buscar equipamento": "Search equipment",
    "equipment.Desvincular": "Unlink",
    "equipment.Editar": "Edit",
    "equipment.sem conteúdo": "THERE IS STILL NO EQUIPMENT HERE :(",
    "equipment.description.sem conteúdo": "Click the Add Equipment button, located in the top right corner, and link your ovens.",
    "equipment.editar equipamento": "edit equipment",
    "equipment.equipamento editado com sucesso!": "Equipment edited successfully!",
    "equipment.não foi possível editar o equipamento. Tente novamente mais tarde": "It was not possible to edit the equipment. Try again later",
    "equipment.Menu exportado com sucesso!": "Menu exported successfully!",
    "equipment.Não foi possível exportar o menu. Tente novamente mais tarde": "It was not possible to export menu. Try again later",
    "equipment.Selecione pelo menos um equipamento para enviar o menu": "Select at least one equipment to send the menu",
    "equipment.Informações do menu": "Menu information",
    "equipment.Procurar receita ou grupo": "Search recipe or group",
    "equipment.Grupo": "Group",
    "equipment.Grupos de equipamentos": "Equipment groups",
    "equipment.Receita": "Recipe",
    "equipment.Quantidade": "Quantity",
    "equipment.Receitas mais preparadas no equipamento durante o período": "Most prepared recipes on the equipment during the period",
    "equipment.Informações de limpeza": "Cleaning information",
    "equipment.Data da limpeza": "Cleaning date",
    "equipment.Hora da limpeza": "Cleaning hour",
    "equipment.nome": "Name",
    "equipment.modelo": "Model",
    "equipment.categoria": "Category",
    "equipment.loja": "Store",
    "desvincular equipamento": "Unlink equipment",
    "equipment.unlink.paragrafo 1":
    "Do you wish to unlink the equipment from the IOK platform?",
    "equipment.unlink.paragrafo 2":
    "By doing so, it will not be possible to manage your settings and menu through the platform, unless you link the equipment again, following the connection instructions.",
    "equipamento desvinculado com sucesso!":
    "Equipment unlinked successfully!",
    "equipment.ocorreu um erro. Tente novamente mais tarde":
    "An error has occurred. Try again later",
    "equipment.sim": "Yes",
    "equipment.não": "No",
    "equipment.Encerrar acesso remoto": "End remote access",
    "equipment.Horas sem limpeza": "Hours without cleaning",
    "equipment.Histórico de eventos": "Events history",
    "equipment.Histórico de eventos do forno": "Oven events history",
    "equipment.Histórico de eventos da fermentadora": "Proofer events history",
    "equipment.Receitas executadas": "Executed recipes",
    "equipment.Hoje": "Today",
    "equipment.Tempo de porta aberta": "Door open time",
    "equipment.Tempo médio aproximado": "Average time",
    "equipment.Filtrar eventos": "Filter events",
    "equipment.Evento": "Event",
    "equipment.Data": "Date",
    "equipment.ERRO SENSOR RI": "Error with lower resistance sensor",
    "equipment.ERRO COM INV. DE FREQ.": "Error with frequency inverter",
    "equipment.ERRO MAGNETRON": "Magnetron error",
    "equipment.ERRO SENSOR CAMARA": "Error with camara sensor",
    "equipment.ERRO CAN": "CAN error",
    "equipment.Erro INVERSOR DE FREQUENCIA": "Frequency inverter error",
    "equipment.ERRO DO MODELO DO EQUIPAMENTO": "Equipment's model error",
    "equipment.ERRO PAINEL": "Panel error",
    "equipment.ERRO INV.FREQ.STATUS": "Frequency inverter error status",
    "equipment.ERRO SENSOR BOARD": "Board's sensor error",
    "equipment.ERRO ENERGY": "Energy error",
    "equipment.ERRO I2C": "I2C error",
    "equipment.EQUIPAMENTO LIGADO": "Equipment on",
    "equipment.EQUIPAMENTO DESLIGADO": "Equipment off",
    "equipment.Plataforma": "Platform",
    "equipment.Forno": "Oven",
    "equipment.Origem": "Origin",
    "equipment.Locais": "Locations",
    "equipment.não foi possível carregar as entidades": "It was not possible to load entities",
    "equipment.conceder acesso remoto a": "Grant remote access to",
    "equipment.atualizar software": "update software",
    "equipment.suporte": "support",
    "equipment.PIN": "PIN",
    "equipment.nome do equipamento": "Equipment's name",
    "equipment.vinculado à loja": "Linked to store",
    "equipment.cadastrar loja": "Register store",
    "equipment.informe o PIN do forno": "Enter the oven PIN",
    "equipment.preencha o PIN do forno": "Fill in the oven PIN",
    "equipment.adicione um nome para facilitar seu reconhecimento":
    "Add a name to make it easier to recognize",
    "equipment.preencha o nome do equipamento":
    "Fill in the equipment's name",
    "equipment.selecionar": "Select",
    "equipment.nome fantasia": "Fantasy name",
    "equipment.informe o nome fantasia": "Enter the fantasy name",
    "equipment.preencha o nome fantasia": "Fill in the fanatsy name",
    "equipment.CNPJ": "CNPJ",
    "equipment.XX.XXX.XXX/0001.XX": "XX.XXX.XXX/0001.XX",
    "equipment.preencha o CNPJ": "Fill in the CNPJ",
    "equipment.CEP": "Postal code",
    "equipment.00000-000": "00000-000",
    "equipment.preencha o CEP": "Fill in the postal code",
    "equipment.cidade": "City",
    "equipment.informe a cidade": "Enter the city",
    "equipment.preencha a cidade": "Fill in the city",
    "equipment.UF": "State",
    "equipment.bairro": "Neighborhood",
    "equipment.informe o bairro": "Enter neighborhood",
    "equipment.endereço": "Address",
    "equipment.informe o seu endereço": "Enter your address",
    "equipment.preencha o seu endereço": "Fill in your address",
    "equipment.Nº": "Nº",
    "equipment.equipamento cadastrado com sucesso!":
    "Equipment registered successfully!",
    "equipment.ocorreu um erro": "An error has occurred",
    "equipment.preencha o modelo": "Fill in the model",
    "equipment.selecione uma categoria": "Select a category",
    "equipment.selecione uma loja": "Select a store",
    "equipment.preencha o bairro": "Fill in the neighborhood",
    "equipment.não foi possível cadastrar o equipamento. Tente novamente mais tarde":
    "It was not possible to register the equipment. Try again later",
    "equipment.loja cadastrada com sucesso": "Store registered successfully",
    "equipment.não foi possível cadastrar a loja. Tente novamente mais tarde":
    "It was not possible to register the store. Try again later",
    "equipment.equipment": "equipment",
    "equipment.stores": "stores",
    "equipment.search equipment": "seach equipment",
    "equipment.add equipment": "add equipment",
    "equipment.update equipment": "update equipment",
    "equipment.plus equipment": "+ equipment",
    "equipment.Procurar equipamento": "Search equipment",
    "equipment.EQUIPAMENTOS": "EQUIPMENT",
    "equipment.Atualizar equipamento": "Update equipment",
    "equipment.Atualizar equipamentos": "Update equipment",
    "equipment.confirmar": "confirm",
    "equipment.Selecione os modelos que deseja atualizar:": "Select the models you wish to update:",
    "equipment.Como deseja realizar a atualização?": "How do you wish to proceed with the update?",
    "equipment.Enviar atualização pela plataforma (internet)": "Send updates through platform (internet)",
    "equipment.Salvar arquivo de atualização no dispositivo": "Save update file to device",
    "equipment.Linha Express": "Express series",
    "equipment.Escolha como deseja realizar a atualização": "Choose how you wish to proceed with the update",
    "equipment.Selecione ao menos um modelo de equipamento para atualizar": "Select at least one equipment model to update",
    "equipment.Status: ": "Status: ",
    "equipment.Número de série:": "Serial number",
    "equipment.Menu:": "Menu",
    "equipment.Status:": "Status: ",
    "equipment.Número de série": "Serial number",
    "equipment.Menu": "Menu",
    "equipment.Loja: ": "Store: ",
    "equipment.End:": "Address: ",
    "equipment.Endereço:": "Address: ",
    "equipment.Cidade:": "City: ",
    "equipment.CEP:": "Postal code: ",
    "equipment.Atualização de software enviada com sucesso!": "Software update sent successfully!",
    "equipment.Não foi possível enviar a atualização de software. Tente novamente mais tarde": "It was not possible to send the software update. Try again later",
    "equipment.Download realizado com sucesso": "Download completed successfully",
    "equipment.Não foi possível realizar o download. Tente novamente mais tarde": "It was not possible to complete the download. Try again later",
    "equipment.Solicitação processada com erro. Tente novamente mais tarde": "Request processed with error. Try again later",
    "equipment.Preencha o nome da versão": "Fill in the version name",
    "equipment.Informe aqui todas as alterações desta nova versão": "Enter here all the changes in this new version",
    "equipment.Nova versão de software atualizada com sucesso!": "New sotware version updated successfully!",
    "equipment.Informe pelo menos uma mudança nesta versão": "Enter at least one change in this version",
    "equipment.Falha ao ler o arquivo": "Failed to read file",
    "equipment.selecionar tipo": "select type",
    "equipment.selecione o tipo da versão": "select version type",
    "equipment.atualização": "UPDATE",
    "equipment.Selecione abaixo o que deseja fazer:": "Select below what you wish to do:",
    "equipment.Atualizar meus equipamentos": "Update my equipment",
    "equipment.Enviar atualização para usuários selecionados": "Send update to selected users",
    "equipment.ENVIAR": "SEND",
    "equipment.ENVIAR ATUALIZAÇÃO": "SEND UPDATE",
    "equipment.Selecione os e-mails para os quais deseja enviar a atualização:": "Select the e-mails you wish to send the update to:",
    "equipment.A atualização disponibilizada no dia": "The available update on the day ",
    "equipment.referente ao equipamento": "regarding the equipment ",
    "equipment.contempla o seguinte:": "considers the following:",
    "equipment.Selecionar arquivo para envio": "Select file to send",
    "equipment.Por favor, selecione um arquivo .tar": "Please select a file .tar",
    "equipment.Selecione o modelo do equipamento:": "Select the equipment model:",
    "equipment.Selecione uma opção": "Select an option",
    "equipment.Nomeie a versão": "Name the version",
    "equipment.Clique sobre o arquivo que deseja baixar:": "Click on the file you want to download:",
    "equipment.Baixar atualização": "Download update",
    "equipment.Versões": "Versions",
    "equipment.e superiores": "and higher",
    "equipment.name": "name",
    "equipment.model": "model",
    "equipment.category": "category",
    "equipment.store": "store",
    "FIT Express/FIT ST": "FIT Express/FIT ST",
    "Copa/Single Mag/Rocket": "Copa/Single Mag/Rocket",
    "Forza STi": "Forza STi",
    "TSi": "TSi",
    "FIT Express": "FIT Express",
    "FIT ST": "FIT ST",
    "FIT Express, FIT ST": "FIT Express, FIT ST",
    "Copa Express, Rocket Express, Copa Single Mag": "Copa Express, Rocket Express, Copa Single Mag",
    "equipment.e": "and",
    "equipment.Últimas versões de software:": "Latest software versions: ",
    "equipment.Você não possui nenhum equipamento desatualizado": "You don't have any outdated equipment",
    "equipment.grupos": "groups",
    "equipment.não foi possível carregar os grupos de equipamentos da companhia": "Unable to load company equipment groups",
    "equipment.vinculado ao grupo": "Linked to the group",
    "equipment.selecione um grupo": "Select a group",
    "equipment.cadastrar grupo": "Register group",
    "equipment.Número de Série": "SN",
    "equipment.Versão": "Version",
    "equipment.não foi possível cadastrar o equipamento. Selecione ou cadastre um grupo": "Could not register the equipment. Select or register a group",
    "equipment.CRIE GRUPOS DE EQUIPAMENTOS!": "CREATE EQUIPMENT GROUPS!",
    "equipment.Para que os usuários vinculados à conta possam visualizar os equipamentos você precisa:": "So that users linked to the account can view the equipment, you need to:",
    "equipment.1) Criar grupo(s);": "1) Create group(s);",
    "equipment.2) Atribuir equipamento(s) ao grupo;": "2) Assign equipment(s) to the group;",
    "equipment.3) Atribuir usuário(s) ao grupo.": "3) Assign user(s) to the group.",
    "equipment.Status software": "Software Status",
    "equipment.Status menu": "Menu Status",
    "equipment.Pendente": "Pending",
    "equipment.Aceito": "Accepted",
    "equipment.Recusado": "Rejected",
    "equipment.Atualizar software": "Update software",
    "equipment.Deseja enviar a atualização para o equipamento selecionado?": "Do you want to send the update to the selected equipment?",
    "equipment.Companhia": "Company",
    "equipment.Exportar menu": "Export menu",
    "equipment.companhias": "Companies",
    "equipment.Nome da companhia": "Company name",
    "equipment.Procurar equipamento, usuário ou companhia": "Search for equipment, user or company",
    "equipment.Versão da power": "Power version",
    "equipment.AINDA NÃO HÁ DADOS DE RECEITAS AQUI :(": "THERE IS NO RECIPE DATA HERE YET :(",
    "equipment.AINDA NÃO HÁ DADOS DE LIMPEZAS AQUI :(": "THERE IS NO CLEANING DATA HERE YET :(",
    "equipment.AINDA NÃO HÁ DADOS DE EVENTOS AQUI :(": "THERE IS NO EVENT DATA HERE YET :(",
    "ID": "ID",
    "equipment.Hora": "Hour",
    "equipment.EVENTOS MAIS OCORRIDOS NO EQUIPAMENTO DURANTE O PERÍODO": "MOST OCCURRED EVENTS ON THE EQUIPMENT DURING THE PERIOD",
    "equipment.hour": "h",
    "equipment.minutes": "min",
    "equipment.date format": "DD/MM/YYYY",
    "equipment.preparada": "prepared",
    "equipment.vezes": "times",
    "equipment.vez": "time",
    "equipment.Ver": "View",
    "equipment.Os dados são mantidos pela plataforma pelo tempo necessário para suporte, manutenção e evolução dos produtos.": "Data is retained by the platform for as long as necessary to support, maintain, and improve the products.",
    "equipment.Ligado": "On",
    "equipment.Desligado": "Off",
    "equipment.CAN ERROR": "CAN Error",
    "equipment.CAMERA SENSOR ERROR": "Chamber sensor error",
    "equipment.STEAM/RI SENSOR ERROR": "RI sensor error",
    "equipment.PROBE 1 ERROR": "Probe 1 alert",
    "equipment.PROBE 2 ERROR": "Probe 2 alert",
    "equipment.PROBE 3 ERROR": "Probe 3 alert",
    "equipment.PROBE 4 ERROR": "Probe 4 alert",
    "equipment.PROBE 5 ERROR": "Probe 5 alert",
    "equipment.PROBE 6 ERROR": "Probe 6 alert",
    "equipment.GENERAL PROBE ERROR": "General probe error",
    "equipment.WATER LACK ERROR": "Water lack alert",
    "equipment.HIGH PANEL TEMPERATURE ERROR": "High panel temperature alert",
    "equipment.FREQUENCY INVERTER GENERAL ERROR": "Frequency inverter general error",
    "equipment.FREQUENCY INVERTER COMMUNICATION ERROR": "Frequency inverter communication alert",
    "equipment.FREQUENCY INVERTER STATUS ERROR": "Frequency inverter status alert",
    "equipment.CLEANING NOT COMPLETED ERROR": "Incomplete cleaning alert",
    "equipment.MAGNETRON ERROR": "Magnetron alert",
    "equipment.EQUIPMENT FAMILY/MODEL ERROR": "Equipment model error",
    "equipment.BOARD TEMPERATURE SENSOR ERROR": "Board temperature sensor alert",
    "equipment.ENERGY MODULE ERROR": "Energy module error",
    "equipment.POWER BOARD I2C BUS ERROR": "Power board error",
    "equipment.GAS SYSTEM ERROR": "Gas error",
    "equipment.VERY HIGH PANEL TEMPERATURE ERROR": "Super high panel temperature error",
    "equipment.POWER ON": "On",
    "equipment.POWER OFF": "Off",
    "equipment.DOOR OPENED": "Door open",
    "equipment.DOOR CLOSED": "Door closed",
    "equipment.CLEANING CANCELED ERROR": "Cleaning canceled by user",
    "equipment.PIN não encontrado. Por favor, verifique e tente novamente": "PIN not found. Please check and try again",
    "equipment.Ultracongeladores": "Blast chillers",
    "equipment.PIN já vinculado a outra conta": "PIN is already linked to another account",
    "equipment.Equipamento já cadastrado nesta conta": "Equipment is already registered to this account",
    "equipment.Não foi possível validar o PIN. Tente novamente": "The PIN could not be validated. Please try again",
    "equipment.Online": "On",
    "equipment.Offline": "Off",
    "equipment.Exibir apenas eventos": "Show events only",
    "equipment.Endereço": "Address",
    "equipment.EQUIPMENT CONNECTED TO THE PLATFORM": "Equipment connected to the platform",
    "equipment.EQUIPMENT DISCONNECTED FROM THE PLATFORM": "Equipment disconnected from the platform",
    "equipment.MENU RECEIVED FROM THE PLATFORM": "Menu from the platform accepted by the user",
    "equipment.MENU REJECTED BY THE USER": "Menu from the platform rejected by the user",
    "equipment.CONNECTED TO THE INTERNET": "Connected to the internet",
    "equipment.DISCONNECTED FROM THE INTERNET": "Disconnected from the internet",
    "equipment.Infelizmente, não há versões compatíveis com este equipamento que realizem o envio de dados.": "Unfortunately, there are no versions compatible with this equipment that can send data.",
    "equipment.O equipamento": "The equipment",
    "equipment.deve ser atualizado para a versão mais recente de software para que passe a enviar os dados para a plataforma": "must be updated to the latest software version to start sending data to the platform",
    "equipment.Versão do seu equipamento": "Version of your equipment",
    "equipment.Versão disponível": "Available version",
    "equipment.Selecione abaixo como deseja enviar a atualização para seu equipamento": "Select below how you want to send the update to your equipment",
    "equipment.Salvar no dispositivo": "Save on device",
    "equipment.Enviar pela internet": "Send via internet",
    "equipment.Cliente": "Client",
    "equipment.NÚMERO DE SÉRIE NÃO ENCONTRADO": "SERIAL NUMBER NOT FOUND",
    "equipment.BUSCAR": "SEARCH",
    "equipment.ACESSADOS RECENTEMENTE": "RECENTLY ACCESSED",
    "equipment.SEM BUSCAS RECENTES": "NO RECENT SEARCHES",
    "equipment.description.SEM BUSCAS RECENTES": "Use the serial number to search for equipment.",
    "equipment.Procurar equipamento pelo número de série": "Search for equipment by serial number",
    "equipment.AIR FILTER CLEANING COMPLETED": "Air filter cleaning complete",
    "equipment.AIR FILTER CLEANING REJECTED": "Air filter cleaning rejected",
    "equipment.CATALYTIC FILTER CLEANING COMPLETED": "Catalytic filter cleaning complete",
    "equipment.CATALYTIC FILTER CLEANING REJECTED": "Catalytic filter cleaning rejected",
    "equipment.Endereço (rua, avenida, rodovia)": "Address (street, avenue, highway)",
    "equipment.Nº/Km": "Nº/Km",
    "equipment.ID do equipamento": "Equipment ID",
    "equipment.Todo equipamento deve ser vinculado a um grupo. Selecione um grupo da lista ou cadastre um novo clicando em + Cadastrar grupo.": "All equipment must be linked to a group. Select a group from the list or register a new one by clicking + Register group.",
    "equipment.Nomeie seu forno": "Name your oven",
    "equipment.Para visualizar o PIN, acesse nas configurações do equipamento a Plataforma Virtual IOK.": "To view the PIN, access the IOK Virtual Platform in the equipment settings.",
    "equipment.Vinculação IOK": "IOK Binding",
   "equipment.Preparações": "Preparations",
    "equipment.recipeTable.recipe": "Recipe",
    "equipment.recipeTable.origin": "Ori.",
    "equipment.recipeTable.executions": "Exec.",
    "equipment.recipeTable.lastExecution": "Last execution",
    "equipment.Última preparação": "Last preparation",
    "equipment.Pico de preparações": "Peak of preparations",
    "equipment.informações da semana": "week information",
    "equipment.horários de pico": "peak times",
    "equipment.localização": "location",
    "equipment.AINDA NÃO HÁ NENHUMA LOCALIZAÇÃO CADASTRADA :(": "THERE IS NO LOCATION REGISTERED YET :(",
    "equipment.description.AINDA NÃO HÁ NENHUMA LOCALIZAÇÃO CADASTRADA :(": "Click the button located in the top right corner and add locations.",
    "equipment.Procurar empresa ou local": "Search for company or location",
    "equipment.Adicionar localização": "Add location",
    "equipment.Adicionar": "Add",
    "equipment.espaço": "Room",
    "equipment.local": "Local",
    "equipment.EXCLUIR LOCALIZAÇÃO": "DELETE LOCATION",
    "equipment.Você deseja excluir esta localização?": "Do you want to delete this location?",
    "equipment.Ao fazer isso, os equipamentos atrelados à ela não exibirão nenhuma localização, sendo necessário informar um novo local para eles.": "When doing this, the equipment linked to it will not display any location, making it necessary to provide a new location for them.",
    "equipment.Localização deletada com sucesso!": "Location deleted successfully!",
    "equipment.Erro ao deletar a localização. Tente novamente mais tarde": "Error deleting location. Try again later",
    "equipment.Não foi possivel deletar a localização": "Unable to delete location",
    "equipment.Localização adicionada com sucesso!": "Location added successfully!",
    "equipment.Não foi possível adicionar a localização. Tente novamente mais tarde": "Unable to add location. Try again later",
    "equipment.Nome do espaço": "Room name",
    "equipment.Informe o nome do espaço": "Enter the name of the room",
    "equipment.Preencha o nome do espaço": "Fill in the name of the room",
    "equipment.país": "Country",
    "equipment.informe o país": "Enter the country",
    "equipment.preencha o país": "Fill in the country",
    "equipment.Localização editada com sucesso!": "Location edited successfully!",
    "equipment.Não foi possível editar a localização. Tente novamente mais tarde": "Unable to edit location. Try again later",
    "equipment.Editar localização": "Edit location",
    "equipment.horário de pico": "rush hour",
    "equipment.preparações do dia": "preparations of the day",
    "equipment.Horário": "Time",
    "equipment.dia selecionado": "selected day",
    "equipment.A limpeza adequada e diária do forno auxilia em seu funcionamento correto e impacta na garantia.": "Proper and daily cleaning of the oven helps it function correctly and impacts the warranty.",
    "equipment.Total de limpezas realizadas:": "Total cleaning performed:",
    "equipment.Limpezas não concluídas:": "Cleanings not completed:",
    "equipment.Desde a vinculação do forno a IOK": "From connecting the oven to IOK",
    "equipment.Equipamento ligado há:": "Equipment on for:",
    "equipment.Total de receitas preparadas:": "Total prepared recipes:",
    "equipment.Receitas preparadas": "Prepared recipes",
    "equipment.Aberturas de porta": "Door openings",
    "equipment.Desde a última vez que o forno foi ligado": "Since the last time the oven was turned on",
    "equipment.Preparação": "Preparation",
    "equipment.Nenhuma localização criada": "No locations created",
    "equipment.Acesso remoto": "Remote access",
    "equipment.Informe o ID da empresa que poderá acessar remotamente seu forno. Use ; para separar IDs.": "Enter the ID of the company that can remotely access your oven. Use ; to separate IDs.",
    "equipment.O acesso remoto permite que as empresas selecionadas enviem menus e atualizações para seu equipamento.": "Remote access allows selected companies to send menus and updates to your equipment.",
    "equipment.Concedo acesso remoto à Prática oficial.": "I grant remote access to the official Prática.",
    "equipment.Deseja selecionar outros equipamentos vinculados à sua conta para conceder acesso remoto a eles?": "Do you want to select other devices linked to your account to grant them remote access?",
    "equipment.Selecione abaixo os equipamentos para os quais deseja conceder acesso remoto à": "Select below the equipment for which you want to grant remote access to the",
    "equipment.Acesso remoto concedido com sucesso!": "Remote access granted successfully!",
    "equipment.Selecione pelo menos um equipamento": "Select at least one device",
    "equipment.Não foi possível editar os equipamentos. Tente novamente mais tarde": "Unable to edit equipment. Try again later",
    "equipment.Solicitar atendimento": "Request service",
    "equipment.Relate um problema": "Report a problem",
    "equipment.Descreva aqui o problema de seu equipamento": "Describe your equipment problem here",
    "equipment.Não foi possível enviar sua solicitação de atendimento. Tente mais tarde": "We were unable to send your service request. Try later",
    "equipment.Solicitação técnica enviada com sucesso!": "Technical request sent successfully!",
    "equipment.Enviar": "Send",
    "equipment.Solicitação de atendimento": "Service request",
    "equipment.Informações do magnetron": "Magnetron Information",
    "equipment.Vida útil aproximada": "Approximate Lifespan",
    "equipment.MAGNETRON USAGE HOURS": "Magnetron Usage Hours",
    "equipment.Filtros": "Filters",
    "equipment.Filtrar": "Filter",
    "equipment.Limpar filtros": "Clear filters",
    "equipment.Procurar por modelo, versão ou país": "Search by model, version or country",
    "equipment.Procurar equipamento, NS, modelo, versão ou país": "Search for equipment, SN, model, version, or country",
    "equipment.Atendimento": "Service",
    "equipment.Eventos mais ocorridos no equipamento durante o período": "Events most occurring on the equipment during the period",
    "equipment.EQUIPAMENTO SEM NÚMERO DE SÉRIE": "EQUIPMENT WITHOUT SERIAL NUMBER",
    "equipment.Os seguintes IDs não pertencem a uma companhia do tipo 'Distribuidor' e foram removidos": "The following IDs do not belong to a company of type 'Distributor' and have been removed",
    "equipment.BAIXAR VERSÕES": "DOWNLOAD VERSIONS",
    "equipment.Compatível com todas as versões da IHM.": "Compatible with all HMI versions.",
    "equipment.Compatível apenas com a versão 2.0.0C da Power.": "Only compatible with Power version 2.0.0C.",
    "equipment.Procurar evento": "Search event",
    "equipment.Forno conectado": "Oven connected",
    "equipment.Limpeza de filtro de ar": "Air filter cleaning",
    "equipment.Limpeza de filtro catalítico": "Catalytic filter cleaning",
    "equipment.Forno ligado": "Oven on",
    "equipment.Inversor de frequência": "Frequency inverter",
    "equipment.Temperatura de painel": "Panel temperature",
    "equipment.Sensor da câmara": "Chamber sensor",
    "equipment.Magnetron": "Magnetron",
    "equipment.Power": "Power",
    "equipment.Informações de menu": "Menu information",
    "equipment.Limpeza": "Cleaning",
    "equipment.Limpeza realizada": "Cleaning performed",
    "equipment.Limpeza recomendada": "Cleaning recommended",
    "equipment.O equipamento já está utilizando a versão mais recente do software.": "The equipment is already using the latest version of the software.",
    "equipment.Atenção: o cálculo da vida útil do magnetron não considera o tempo de uso anterior à versão F1.1.0.": "Attention: the calculation of the magnetron's useful life does not consider the time of use prior to version F1.1.0.",
    "equipment.Equipamentos com erro": "Equipment with errors",
    "equipment.Em breve você terá acesso a dados importantes enviados pelo forno, como horário de pico, receitas mais executadas, histórico de higienizações, eventos ocorridos e mais! Lembre-se de manter seu equipamento sempre atualizado com as novas versões disponíveis na plataforma.":
    "Soon you will have access to important data sent by the oven, such as peak times, most executed recipes, cleaning history, events that occurred and more! Remember to keep your equipment always up to date with the new versions available on the platform.",
    "equipment.Para que a execução da limpeza seja registrada no equipamento e enviada à plataforma, é necessário seguir o passo a passo completo do procedimento no forno. Não é obrigatório assistir aos vídeos dos passos, quando disponíveis.":
    "For the cleaning to be recorded on the equipment and sent to the platform, it is necessary to follow the complete step-by-step procedure in the oven. It is not mandatory to watch videos of the steps, when available.",
    "equipment.Horas de uso": "Operating hours",
    "equipment.A contagem das horas de uso do magnetron são realizadas a partir da versão F1.0.6": "The counting of the magnetron operating hours is performed starting from version F1.0.6",
    "equipment.A atualização do software leva cerca de 15 minutos. Durante o processo, o forno reiniciará e exibirá uma tela azul até a conclusão. Para evitar falhas, mantenha-o ligado e conectado à internet. Caso opte por atualizar via pen drive, não o remova até a conclusão.": "The software update takes about 15 minutes. During the process, the oven will restart and display a blue screen until completion. To avoid errors, keep it powered on and connected to the internet. If you choose to update via USB drive, do not remove it until the process is complete.",
    'equipment.Equipamento {name} com software {version} devem ser atualizador via USB. A atualização do software leva cerca de 15 minutos. Durante o processo, o forno reiniciará e exibirá uma tela azul até a conclusão. Para evitar falhas, mantenha-o ligado e conectado à internet. Caso opte por atualizar via pen drive, não o remova até a conclusão.': "Equipment {name} with software {version} must be updated via USB. The software update takes about 15 minutes. During the process, the oven will restart and display a blue screen until completion. To avoid errors, keep it powered on and connected to the internet. If you choose to update via USB drive, do not remove it until the process is complete.",
    "equipment.Observação": "Note:",
    "equipment.Para versões ST2.0.0 e superiores, o envio de atualização pela plataforma (Wi-fi) seguirá disponibilizado normalmente.": "For versions ST2.0.0 and above, the update via the platform (Wi-Fi) will continue to be available as usual.",
    "equipment.Aqui você encontra informações gerais sobre o equipamento;": "Here you will find general information about the equipment;",
    "equipment.Ao clicar nestes botões você consegue solicitar atendimento para seu forno e exportar seus dados em planilhas do Excel;": "By clicking on these buttons, you can request support for your oven and export it's data to Excel spreadsheets;",
    "equipment.Nos quadros abaixo você encontra informações detalhadas sobre execuções de receitas;": "In the panels below, you will find detailed information about recipe preparations;",
    "equipment.Horário de pico;": "Peak hours;",
    "equipment.Informações referentes a higienização;": "Information related to cleaning;",
    "equipment.E histórico de eventos;": "And event history;",
    "equipment.Lembre-se de que é necessário selecionar o período do qual deseja visualizar os dados. É possível fazer isso ao clicar sobre o calendário dos quadros e ao selecionar filtros.": "Remember that you need to select the period for which you want to view the data. You can do this by clicking on the calendar in the panels and selecting filters.",
    "equipment.Baixando o arquivo... Ele estará disponível em breve!": "Downloading the file... It will be available soon!",
    "equipment.A contagem das horas de uso do magnetron são realizadas a partir da versão F1.1.0": "The counting of the magnetron operating hours is performed starting from version F1.1.0",
    "equipment.Data de fabricação": "Manufacturing date",
    "equipment.manutenção": "maintenance",
    "equipment.Ao buscar e localizar um número de série, será aberto um canal temporário diretamente com o forno, permitindo o compartilhamento de seus dados de manutenção. Esses dados não serão armazenados na plataforma, sendo necessário realizar uma nova busca sempre que desejado.":
    "When searching for and locating a serial number, a temporary channel will be opened directly with the oven, allowing the sharing of its maintenance data. This data will not be stored on the platform, requiring a new search whenever desired.",
    "equipment.INFORME UM NÚMERO DE SÉRIE E CLIQUE EM BUSCAR": "ENTER A SERIAL NUMBER AND CLICK SEARCH",
    "equipment.Apenas os modelos FIT Express / FIT Single Mag / FIT XL com a versão de software F2.1.0 enviarão dados de manutenção. As informações, principalmente as dos contadores, serão contabilizadas a partir dessa versão.": "Only FIT Express / FIT Single Mag / FIT XL models with software version F2.1.0 will send maintenance data. Information, especially that of the counters, will be counted from this version onwards.",
    "equipment.Procurar número de série": "Search for serial number",
    "equipment.Alerta": "Alert",
    "equipment.Local": "Location",
    "equipment.Software": "Software",
    "equipment.Forno sem limpeza há": "Oven without cleaning for",
    "equipment.Horário de pico": "Peak hours",
    "equipment.HP": "PH",
    "equipment.RECIPE STARTED": "Recipe started",
    "equipment.RECIPE CANCELED": "Recipe canceled by user",
    "equipment.RECIPE COMPLETED": "Recipe successfully completed",
    "equipment.DOOR OPENED RECIPE": "Door opened during recipe",
    "equipment.DOOR CLOSED RECIPE": "Door closed during recipe",
    "equipment.Receitas iniciadas": "Started recipes",
    "equipment.Receitas concluídas": "Completed recipes",
    "equipment.Receitas interrompidas": "Interrupted recipes",
    "equipment.Total de receitas concluídas:": "Total completed recipes:",
    "equipment.TOTAL DE RECEITAS INTERROMPIDAS": "TOTAL INTERRUPTED RECIPES",
    "equipment.DOWNLOAD_PROGRESS": "DOWNLOADING FILE... PLEASE WAIT, PROGRESS: {progress}%",
    "equipment.Informe o número de série do forno": "Enter the oven serial number",
    "equipment.preencha o número de série do forno": "Fill in the oven serial number",
    "equipment.NÚMERO DE SÉRIE NÃO CADASTRADO": "SERIAL NUMBER NOT REGISTERED",
    "equipment.Número de série não encontrado. Por favor, verifique e tente novamente": "Serial number not found. Please check and try again",
    "equipment.Antes de iniciar a atualização, faça o backup das receitas salvas no equipamento para garantir a integridade dos dados. O backup pode ser feito via pen drive ou pela plataforma. Isso permite a recuperação das informações em caso de perda.": "Before starting the update, back up the recipes saved on the equipment to ensure data integrity. The backup can be done via USB flash drive or through the platform. This allows for the recovery of information in case of loss.",
    "equipment.MENU RECEIVED FROM THE PLATFORM BY FORCED METHOD": "Menu received from the platform by forced update",
    "equipment.Nome da receita não encontrado": "Recipe name not found",
    "equipment.passos": "{count, plural, one {step} other {steps}}",
    "equipment.minAbbreviation": "min",
    "equipment.secAbbreviation": "sec",
    "equipment.status online": "online status",
    "equipment.status offline": "offline status",
    "equipment.software accepted": "software accepted",
    "equipment.menu accepted": "menu accepted",
    "equipment.software pending": "software pending",
    "equipment.menu pending": "menu pending",
    "equipment.software refused": "software refused",
    "equipment.menu refused": "menu refused",
    "equipment.ENCERRAR SESSÃO": "END SESSION",
    "equipment.Configurações": "Settings",
    "equipment.Tempo de preaquecimento": "Preheating time",
    "equipment.Formato de data": "Date format",
    "equipment.Formato de hora": "Time format",
    "equipment.Unidade de temperatura": "Temperature unit",
    "equipment.Aquecer/dourar mais": "Heat/brown more",
    "equipment.Fabricante": "Manufacturer",
    "equipment.Voltagem": "Voltage",
    "equipment.Introdução": "Introduction",
    "equipment.Modelo": "Model",
    "equipment.Modelo definido pelo equipamento": "Defined by the equipment",
    "equipment.Equipamento sem conectividade": "Equipment without connectivity",
    "equipment.Número de série offline inválido": "Enter seven digits, without spaces or a leading zero",
    "equipment.Número de série já cadastrado": "Serial number already registered",
    "equipment.Motor": "Motor",
    "equipment.Hostname": "Hostname",
    "equipment.STATUS DA OPERAÇÃO": "OPERATION STATUS",
    "equipment.ÚLTIMA LIMPEZA": "LAST CLEANING",
    "equipment.VELOCIDADE DO MOTOR": "MOTOR SPEED",
    "equipment.TENSÃO ATUAL": "CURRENT VOLTAGE",
    "equipment.Sensores e periféricos": "Sensors and peripherals",
    "equipment.Contadores": "Counters",
    "equipment.HORAS DE USO DO MOTOR": "MOTOR USAGE HOURS",
    "equipment.HORAS DE USO DO MAGNETRON": "MAGNETRON USAGE HOURS",
    "equipment.ABERTURAS DE PORTA": "DOOR OPENINGS",
    "equipment.ATUAÇÃO DO RELE DA POWER": "POWER RELAY ACTUATION",
    "equipment.ATUAÇÃO DO SENSOR DE PORTA": "DOOR SENSOR ACTUATION",
    "equipment.RECEITAS EXECUTADAS": "EXECUTED RECIPES",
    "equipment.LIMPEZAS EXECUTADAS": "EXECUTED CLEANINGS",
    "equipment.HORAS DE USO DO FILTRO CATALÍTICO": "CATALYTIC FILTER USAGE HOURS",
    "equipment.HORAS DE USO DO FILTRO DE AR": "AIR FILTER USAGE HOURS",
    "equipment.CORRENTE DO MAGNETRON": "MAGNETRON CURRENT",
    "equipment.Erros": "Errors",
    "equipment.Desativado": "Disabled",
    "equipment.Cozinhando": "Cooking",
    "equipment.Pré-aquecendo": "Preheating",
    "equipment.Em espera": "Idle",
    "equipment.Limpando": "Cleaning",
    "equipment.horas": "hours",
    "equipment.Ativado": "Enabled",
    "equipment.Erro CAN": "CAN Error",
    "equipment.Erro no sensor de câmara": "Chamber sensor error",
    "equipment.Alerta de temperatura alta no painel": "High Temperature Alert on Panel",
    "equipment.Erro de temperatura alta no painel": "High Temperature Error on Panel",
    "equipment.Alerta de comunicação no inversor de frequência": "Communication Alert in Frequency Inverter",
    "equipment.Alerta de status no inversor de frequência": "Status Alert in Frequency Inverter",
    "equipment.Alerta na corrente do magnetron": "Magnetron Current Alert",
    "equipment.Erro no modelo do equipamento": "Equipment Model Error",
    "equipment.Erro no módulo de energia": "Power Module Error",
    "equipment.Erro I2C": "I2C Error",
    "equipment.Erro de temperatura alta na placa": "High Temperature Error on Board",
    "equipment.Fechado": "Closed",
    "equipment.Aberto": "Open",
    "equipment.Câmara": "Chamber",
    "equipment.Placa": "Board",
    "equipment.Tensão": "Voltage",
    "equipment.Corrente da placa": "Board Current",
    "equipment.Velocidade do motor": "Motor Speed",
    "equipment.Rele da resistência": "Heating Relay",
    "equipment.Rele de curto circuito": "Short-Circuit Relay",
    "equipment.Ventilador radial": "Radial Fan",
    "equipment.Led vermelho": "Red LED",
    "equipment.Led verde": "Green LED",
    "equipment.Led azul": "Blue LED",
    "equipment.Erro": "Error",
    "equipment.Sensor": "Sensor",
    "equipment.Valor": "Value",
    "equipment.Manutenção da temperatura": "Temperature maintenance",
    "equipment.Manutenção": "Maintenance",
    "equipment.Esfriando": "Cooling down",
    "equipment.CEILING SENSOR ERROR": "Ceiling sensor error",
    "equipment.BALLAST SENSOR ERROR": "Ballast sensor error",
    "equipment.VAPORIZER SENSOR ERROR": "Vaporizer sensor error",
    "equipment.EQUIPMENT CONSUMPTION": "Consumption",
    "equipment.Sensores": "Sensors",
    "equipment.Falta de água": "Water shortage",
    "equipment.Executando Receita": "Running Recipe",
    "equipment.Executando Limpeza": "Running Cleaning",
    "equipment.Dia": "Day",
    "equipment.Semana": "Week",
    "equipment.Mês": "Month",
    "equipment.Tempo": "Time",
    "equipment.Segunda": "Monday",
    "equipment.Terça": "Tuesday",
    "equipment.Quarta": "Wednesday",
    "equipment.Quinta": "Thursday",
    "equipment.Sexta": "Friday",
    "equipment.Sábado": "Saturday",
    "equipment.Domingo": "Sunday",
    "equipment.CONSUMO ESTIMADO": "ESTIMATED CONSUMPTION",
    "equipment.CONSUMO ATUAL": "CURRENT CONSUMPTION",
    "equipment.ECONOMIA COM MODO ECO": "SAVINGS WITH ECO MODE",
    "equipment.MÉDIA SEMANAL": "WEEKLY AVERAGE",
    "equipment.MÉDIA MENSAL": "MONTHLY AVERAGE",
    "equipment.Consumo de energia": "Energy consumption",
    "equipment.CONSUMO ACUMULADO": "ACCUMULATED CONSUMPTION",
    "equipment.MÉDIA DIÁRIA": "DAILY AVERAGE",
    "equipment.mês selecionado": "selected month",
    "equipment.Este valor representa a soma total dos consumos de cada hora do dia.": "This value represents the total sum of consumption for each hour of the day.",
    "equipment.Este valor representa a soma total dos consumos de cada dia.": "This value represents the total sum of consumption for each day.",
    "equipment.Este valor representa a soma total dos consumos de cada semana.": "This value represents the total sum of consumption for each week.",
    "equipment.Este valor representa a soma total dos consumos de cada mês.": "This value represents the total sum of consumption for each month.",
    "equipment.Este valor representa a média do consumo das horas, apresentando assim uma estimativa baseada em seu uso.": "This value represents the average hourly consumption, providing an estimate based on usage.",
    "equipment.Este valor representa a média do consumo de cada dia, apresentando assim uma estimativa baseada em seu uso.": "This value represents the average daily consumption, providing an estimate based on usage.",
    "equipment.Este valor representa a média do consumo semanal, apresentando assim uma estimativa baseada em seu uso.": "This value represents the average weekly consumption, providing an estimate based on usage.",
    "equipment.Este valor representa a média do consumo dos últimos dois meses, apresentando assim uma estimativa baseada em seu uso.": "This value represents the average consumption of the last two months, providing an estimate based on usage.",
    "equipment.Este valor representa a soma total da economia de consumo de cada hora do dia com a utilização do modo Eco.": "This value represents the total hourly consumption savings using Eco mode.",
    "equipment.Este valor representa a soma total da economia de consumo de cada dia com a utilização do modo Eco.": "This value represents the total daily consumption savings using Eco mode.",
    "equipment.Este valor representa a soma total da economia de consumo semanal com a utilização do modo Eco.": "This value represents the total weekly consumption savings using Eco mode.",
    "equipment.Este valor representa a soma total da economia de consumo mensal com a utilização do modo Eco.": "This value represents the total monthly consumption savings using Eco mode.",
    "equipment.Este valor representa a média de consumo dos últimos 7 dias, desconsiderando o dia atual.": "This value represents the average consumption of the last 7 days, excluding the current day.",
    "equipment.Este valor representa a média de consumo das últimas 4 semanas.": "This value represents the average consumption of the last 4 weeks.",
    "equipment.Este valor representa a média de consumo dos últimos 2 meses, desconsiderando o mês atual.": "This value represents the average consumption of the last 2 months, excluding the current month.",
    "equipment.Lista de consumo de energia": "Energy consumption list",
    "equipment.Período": "Period",
    "equipment.Consumo (kWh)": "Consumption (kWh)",
    "equipment.Economia com ECO (kWh)": "Eco savings (kWh)",
    "equipment.Total": "Total",
    "equipment.Sensor de RI": "RI Sensor",
    "equipment.HUMIDITY SENSOR ERROR": "Humidity sensor error",
    "equipment.TEMPERATURE SENSOR ERROR": "Temperature sensor error",
    "equipment.WATER FILTER CLEANING COMPLETED": "Water filter replacement completed",
    "equipment.WATER FILTER CLEANING REJECTED": "Water filter replacement rejected",
    "equipment.HOOD TURNED ON": "Hood turned on",
    "equipment.HOOD TURNED OFF": "Hood turned off",
    "equipment.AUTOMATIC PREHEATING REJECTED": "Automatic preheating rejected",
    "equipment.média diária": "daily average",
    "equipment.média de execução diária": "daily execution average",
    "equipment.FERMENTADORA": "PROOFER",
    "equipment.FORNO": "OVEN",
    "equipment.DIA": "DAY",
    "equipment.Baixado": "Downloaded",
    "equipment.A limpeza diária do equipamento auxilia em seu bom funcionamento e impacta na garantia." : "Daily cleaning of the equipment helps its proper functioning and affects the warranty.",
    "equipment.Desde a vinculação do equipamento ao IOK" : "Since the equipment was linked to IOK",
    "equipment.Total desde a vinculação do equipamento ao IOK": "Total since the equipment was linked to IOK",
    "equipment.Receitas do forno" : "Oven recipes",
    "equipment.Receitas da fermentadora" : "Proofer recipes",
    "equipment.FERM." : "PROOF.",
    "equipment.Fermentadora" : "Proofer",
    "equipment.Coifa" : "Hood",
    "equipment.Preaquecimento automático" : "Automatic preheating",
    "equipment.nivel" : "level",
    "equipment.Fermentadora ligada" : "Proofer on",
    "equipment.Fermentadora desligada" : "Proofer off",
    "equipment.Forno desligado" : "Oven off",
    "equipment.Equipamento ligado" : "Equipment on",
    "equipment.Equipamento desligado" : "Equipment off",
    "equipment.visualizar haccp": "View HACCP",
    "equipment.HACCP": "HACCP",
    "equipment.Atualizar Equip.": "Update equipment",
    "equipment.Consumo de agua por receita": "Water consumption per recipe",
    "equipment.Consumo de energia por receita": "Energy consumption per recipe",
    "equipment.AINDA NAO HA DADOS DE CONSUMO DE AGUA POR RECEITA :(": "THERE IS STILL NO WATER CONSUMPTION DATA PER RECIPE :(",
    "equipment.AINDA NAO HA DADOS DE CONSUMO DE ENERGIA POR RECEITA :(": "THERE IS STILL NO ENERGY CONSUMPTION DATA PER RECIPE :(",
    "equipment.LITROS CONSUMIDOS NO DIA": "LITERS CONSUMED TODAY",
    "equipment.ENERGIA CONSUMIDA NO DIA": "ENERGY CONSUMED TODAY",
    "equipment.CONSUMO ACUMULADO SEMANAL": "WEEKLY ACCUMULATED CONSUMPTION",
    "equipment.CONSUMO ACUMULADO MENSAL": "MONTHLY ACCUMULATED CONSUMPTION",
    "equipment.Receitas": "Recipes",
    "equipment.Consumo (L)": "Consumption (L)",
    "equipment.Exec. dia - (L)": "Preparations/day - (L)",
    "equipment.Exec. semana - (L)": "Preparations/week - (L)",
    "equipment.Exec. mês - (L)": "Preparations/month - (L)",
    "equipment.Exec. dia - (kWh)": "Preparations/day - (kWh)",
    "equipment.Exec. semana - (kWh)": "Preparations/week - (kWh)",
    "equipment.Exec. mês - (kWh)": "Preparations/month - (kWh)",
    "equipment.Agua consumida (litros)": "Water consumed (liters)",
    "equipment.Energia consumida (kWh)": "Energy consumed (kWh)",
    "equipment.temperatura da câmara" : "Chamber temperature",
    "equipment.temperatura do vapor" : "Steam temperature",
    "equipment.último evento listado" : "Last listed event",
    "equipment.temperatura da sonda" : "Probe temperature",
    "equipment.porta" : "Door",
    "equipment.temperatura" : "Temperature",
    "equipment.temperatura atual" : "Current temperature",
    "equipment.média de oscilação diária" : "Average daily fluctuation",
    "equipment.oscilação diária da temperatura" : "Daily temperature fluctuation",
    "equipment.cleaningType.smart": "Smart cleaning",
    "equipment.cleaningType.light": "Light cleaning",
    "equipment.cleaningType.medium": "Medium cleaning",
    "equipment.cleaningType.heavy": "Heavy cleaning",
    "equipment.cleaningType.decalcifying": "Descaling cleaning",
    "equipment.cleaningType.security": "Safety cleaning",
    "equipment.cleaningType.rinse": "Rinse",
    "equipment.cleaningType.custom": "Custom cleaning",
    "equipment.cleaningTypeShort.smart": "Smart",
    "equipment.cleaningTypeShort.light": "Light",
    "equipment.cleaningTypeShort.medium": "Medium",
    "equipment.cleaningTypeShort.heavy": "Heavy",
    "equipment.cleaningTypeShort.decalcifying": "Descaling",
    "equipment.cleaningTypeShort.security": "Safety",
    "equipment.cleaningTypeShort.rinse": "Rinse",
    "equipment.cleaningTypeShort.custom": "Custom",
    "equipment.temperature.sectionTitle": "Temperature",
    "equipment.temperature.currentChamber": "CURRENT CHAMBER TEMPERATURE:",
    "equipment.temperature.currentProbe": "CURRENT PROBE TEMPERATURE:",
    "equipment.temperature.currentSteam": "CURRENT STEAM TEMPERATURE:",
    "equipment.temperature.dailyOscillation": "Daily temperature fluctuation",
    "equipment.temperature.chamberShort": "Chamber",
    "equipment.temperature.probeShort": "Probe",
    "equipment.temperature.axisLabel": "Temperature {unit}",
    "equipment.temperature.dailyAverage": "DAILY AVERAGE",
    "equipment.temperature.weeklyAverage": "WEEKLY AVERAGE",
    "equipment.temperature.monthlyAverage": "MONTHLY AVERAGE",
    "equipment.temperature.lastListedEvent": "Last listed event",
    "equipment.temperature.door": "Door",
    "equipment.temperature.open": "OPEN",
    "equipment.temperature.closed": "CLOSED",
    "equipment.temperature.defineTimeRange": "Define time range:",
    "equipment.temperature.until": "to",
    "equipment.gerar gráficos" : "generate graphs",
    "equipment.Realizada" : "Performed",
    "equipment.Recomendada" : "Recomd.",
    "equipment.Dias da semana" : "Days of the week",
    "equipment.Horário 24h" : "24-hour format",
    "equipment.seg" : "Mon",
    "equipment.ter" : "Tue",
    "equipment.qua" : "Wed",
    "equipment.qui" : "Thu",
    "equipment.sex" : "Fri",
    "equipment.sab" : "Sat",
    "equipment.dom" : "Sun",
    "equipment.Desconhecido" : "Unknown",
    "equipment.AINDA NÃO HÁ DADOS DE CONSUMO DE ENERGIA AQUI :(" : "THERE IS STILL NO ENERGY CONSUMPTION DATA HERE :(",
    "equipment.monthShort.Jan": "Jan",
    "equipment.monthShort.Fev": "Feb",
    "equipment.monthShort.Mar": "Mar",
    "equipment.monthShort.Abr": "Apr",
    "equipment.monthShort.Mai": "May",
    "equipment.monthShort.Jun": "Jun",
    "equipment.monthShort.Jul": "Jul",
    "equipment.monthShort.Ago": "Aug",
    "equipment.monthShort.Set": "Sep",
    "equipment.monthShort.Out": "Oct",
    "equipment.monthShort.Nov": "Nov",
    "equipment.monthShort.Dez": "Dec",
    "equipment.settingsChange.category": "Parameter change",
    "equipment.settingsChange.factoryTitle": "Technical parameter change",
    "equipment.settingsChange.userTitle": "User parameter change",
    "equipment.settingsChange.changedTo": "{label} changed to {value}",
    "equipment.settingsChange.hardResetExecuted": "Hard reset executed",
    "equipment.settingsChange.userFactoryResetExecuted": "User factory reset executed",
    "equipment.settingsChange.magSensorEnabled": "magnetron sensor",
    "equipment.settingsChange.serialNumber": "serial number",
    "equipment.settingsChange.manufactureDate": "manufacturing date",
    "equipment.settingsChange.inverterType": "inverter type",
    "equipment.settingsChange.preHeatMotorSpeed": "preheating motor speed",
    "equipment.settingsChange.voltage": "voltage",
    "equipment.settingsChange.oemModeEnabled": "OEM mode",
    "equipment.settingsChange.controlDoor": "door control",
    "equipment.settingsChange.hardReset": "hard reset",
    "equipment.settingsChange.preHeatTemperatureOne": "preheating temperature 1",
    "equipment.settingsChange.preHeatTemperatureTwo": "preheating temperature 2",
    "equipment.settingsChange.preHeatTime": "preheating time",
    "equipment.settingsChange.preHeatTwoEnabled": "preheating 2",
    "equipment.settingsChange.userFactoryReset": "user factory reset",
    "equipment.settingsChange.enableManualMode": "manual mode",
    "equipment.settingsChange.enableFavorites": "favorites",
    "equipment.settingsChange.enableHeatBrown": "heat/brown more",
    "equipment.settingsChange.enableRepeatRecipe": "repeat recipe",
    "equipment.settingsChange.enableOperatorMode": "operator mode",
    "equipment.settingsChange.enableAutoImport": "automatic import",
    "equipment.settingsChange.enableRecipePreRunMessage": "recipe pre-run message",
    "equipment.settingsChange.controlDoorTwoInputs": "2 inputs",
    "equipment.settingsChange.controlDoorThreeInputs": "3 inputs",
    
    //LOJAS
    "store.Procurar loja": "Search store",
    "store.Excluir": "Delete",
    "store.Editar": "Edit",
    "store.nome": "Name",
    "store.equipamentos": "Equipment",
    "store.Equipamentos vinculados": "Linked equipment",
    "store.cidade": "City",
    "store.estado": "State",
    "store.salvar": "save",
    "store.cadastrar loja": "register store",
    "store.Nome fantasia": "Fantasy name",
    "store.Preencha o nome da loja": "Fill in the store name",
    "store.CNPJ": "CNPJ",
    "store.Preencha o CNPJ da loja": "Fill in the store's CNPJ",
    "store.CEP": "Postal code",
    "store.Preencha o CEP da loja": "Fill in the store's postal code",
    "store.Informe o nome fantasia": "Fill in the fantasy name",
    "store.Cidade": "City",
    "store.Informe a cidade": "Enter the city",
    "store.Preencha a cidade": "Fill in the city",
    "store.UF": "State",
    "store.Preencha o UF da loja": "Fill in the store's state",
    "store.Bairro": "Neighborhood",
    "store.Informe o bairro": "Enter the neighborhood",
    "store.Preencha o bairro da loja": "Fill in the store's neighborhood",
    "store.Endereço": "Address",
    "store.Informe o endereço": "Enter the address",
    "store.Preencha o endereço da loja": "Fill in the store's address",
    "store.Nº": "Nº",
    "store.Preencha o número": "Preencha o número",
    "store.Loja cadastrada com sucesso": "Store registered successfully",
    "store.Erro ao adicionar loja. Tente novamente":
    "Error adding store. Try again",
    "store.Loja deletada com sucesso": "Store deleted successfully",
    "store.Erro ao deletar loja. Tente novamente mais tarde":
    "Error deleting store. Try again later",
    "store.AINDA NÃO HÁ NENHUMA LOJA CADASTRADA :(": "THERE ARE STILL NO REGISTERED STORE :(",
    "store.EXCLUIR LOJA": "DELETE STORE",
    "store.Você deseja excluir a loja da plataforma IOK?": "Do you wish to delete the store from the IOK platform?",
    "store.Ao fazer isso, os equipamentos atrelados à ela não terão vínculo com nenhuma loja, a menos que os vincule novamente.": "By doing so, the equipment linked to it will have no link to any stores, unless you link them again.",
    "store.loja editada com sucesso": "Store edited successfully",
    "store.não foi possível editar a loja. Tente novamente mais tarde": "It was not possible to edit store. Try again later",
    "store.editar loja": "edit store",
    "store.Procurar grupo de equipamentos": "Search equipment group",
    "store.cadastrar grupo": "register group",
    "store.AINDA NÃO HÁ NENHUM GRUPO CADASTRADO :(": "THERE ARE NO GROUP REGISTERED YET :(",
    "store.description.AINDA NÃO HÁ NENHUM GRUPO CADASTRADO :(": "Click the button located in the top right corner and add groups.",
    "store.cadastrar grupo de equipamentos": "register equipment group",
    "store.grupo de equipamentos cadastrado com sucesso!": "Equipment group registered successfully!",
    "store.não foi possível cadastrar o grupo. Tente novamente mais tarde": "Unable to register the group. Try again later",
    "store.Nome do grupo": "Group's name",
    "store.informe o nome do grupo": "Enter the group name",
    "store.preencha o nome do grupo": "Fill in the group name",
    "store.Grupo de equipamentos deletado com sucesso!": "Equipment group deleted successfully!",
    "store.Erro ao deletar o grupo. Tente novamente mais tarde": "Error deleting the group. Try again later",
    "store.EXCLUIR GRUPO DE EQUIPAMENTOS": "DELETE EQUIPMENT GROUP",
    "store.Você deseja excluir este grupo de equipamentos da plataforma IOK?": "Do you want to delete this equipment group from the IOK platform?",
    "store.Ao fazer isso, os equipamentos atrelados à ele não terão vínculo com nenhum grupo, a menos que os vincule novamente.": "When you do this, the equipment linked to it will not be linked to any group, unless you link them again.",
    "store.grupo de equipamentos editado com sucesso!": "Equipment group edited successfully!",
    "store.não foi possível editar o grupo. Tente novamente mais tarde": "Unable to edit the group. Try again later",
    "store.editar grupo de equipamentos": "edit equipment group",
    "store.CEP não encontrado no Brasil": "Postal code not found in Brazil",
    "store.Cadastrar": "Register",
    "store.Equipamentos vinculados": "Linked equipment",
    
    // NAVBAR
    "navbar.home": "home",
    "navbar.cookbook": "cookbook",
    "navbar.my menus": "my menus",
    "navbar.equipment": "equipment",
    "navbar.users": "users",
    "navbar.calls": "services",
    "navbar.settings": "settings",
    "navbar.help": "help",
    "navbar.logout": "Log out",
    "navbar.Editar conta": "Edit account",
    "navbar.API Externa": "External API",
    "navbar.companhias": "Companies",
    "navbar.information": "IOK Information",
    
    // FOOTERBAR
    "footerBar.menu": "Menu",
    "footerBar.cookbook": "Cookbook",
    "footerBar.home": "Home",
    "footerBar.menus": "Menus",
    "footerBar.notifications": "Notifications",
    
    //ATENDIMENTOS
    "calls.ATENDIMENTOS EM ABERTO": "ON GOING SERVICES",
    "calls.ATENDIMENTOS ENCERRADOS": "CLOSED SERVICES",
    
    //MAP
    "map.título": "Location",
    "map.erro": "error!",
    "map.mensagem de erro": "It was not possible to load map.",
    "map.Localização não disponível": "Location not available",
    
    //MODAL
    "modal.CONFIRMAR": "CONFIRM",
    "modal.Salvar alterações": "Save changes",
    "Modal.Há alterações não salvas nos parâmetros dos passos ":
    "There are unsaved changes in step parameters ",
    "Modal.Como deseja proceder?": "How do you wish to proceed?",
    "Modal.Avaliar alterações realizadas": "Confirm changes made",
    "Modal.Descartar alterações": "Discard changes",
    
    //USUÁRIOS
    "user.Nome": "Name",
    "user.E-mail": "E-mail",
    "user.Permissão": "Permission",
    "user.Loja": "Store",
    "user.Status": "Status",
    "user.Excluir": "Delete",
    "user.Editar": "Edit",
    "user.Procurar usuário": "Search user",
    "user.ADICIONAR USUÁRIO": "ADD USER",
    "user.AINDA NÃO HÁ NENHUM USUÁRIO CADASTRADO :(": "THERE ARE NO USERS REGISTERED YET :(",
    "user.+ Usuário": "+ User",
    "user.Informe o nome do usuário": "Enter user name",
    "user.Preencha o nome do usuário": "Fill in the user name",
    "user.Informe o e-mail do usuário": "Enter the user's e-mail",
    "user.Preencha com um e-mail válido": "Enter a valid e-mail address",
    "user.Administrador": "Administrator",
    "user.Usuário": "User",
    "user.Preencha o telefone do usuário": "Fill the user's phone number",
    "user.Selecione a permissão do usuário": "Select user permission",
    "user.Ativo": "Active",
    "user.Inativo": "Inactive",
    "user.Usuário deletado da plataforma com sucesso!": "User removed from platform successfully!",
    "user.Ocorreu um erro. Tente novamente mais tarde": "An error has occurred. Try again later",
    "user.EXCLUIR USUÁRIO": "DELETE USER",
    "user.delete.paragrafo 1": "Do you wish to delete user from the IOK platform?",
    "user.delete.paragrafo 2": "By doing so, they will lose access to all platform tools, unless they are added to it again, following the registration instructions.",
    "user.EDITAR USUÁRIO": "EDIT USER",
    "user.Usuário editado com sucesso!": "User edited successfully!",
    "user.Não foi possível editar este usuário. Por favor, tente mais tarde": "It was not possible to edit this user. Please, try later",
    "user.INFORMAÇÕES DO USUÁRIO": "USER INFORMATION",
    "user.Telefone": "Phone",
    "user.Não foi possível cadastrar este usuário. Por favor, tente mais tarde": "It was not possible to register this user. Please, try later",
    "user.Usuário adicionado com sucesso!": "User added successfully!",
    "user.CRIAR TIPO DE USUÁRIO": "CREATE USER TYPE",
    "user.Criar novo tipo de usuário": "Create new user type",
    "user.Adicionar novo usuário": "Add new user",
    "user.Permissões": "Permissions",
    "user.Preencha o nome do novo tipo de usuário": "Fill in the name of the new user type",
    "user.Selecione pelo menos uma permissão": "Select at least one permission",
    "user.Não foi possível carregar as permissões": "It was not possible to load the permissions",
    "user.Tipo de usuário criado com sucesso!": "User type created successfully!",
    "user.Não foi possível criar este novo tipo de usuário. Por favor, tente mais tarde": "It was not possible to create this new user type. Please, try later",
    "user.Não foi possível carregar os tipos de usuário da companhia": "It was not possible to load the company's user types",
    "user.Tipo de usuário": "User type",
    "user.E-mail já cadastrado na plataforma. Informe um novo e-mail": "E-mail already registered on the platform. Enter a new e-mail",
    "user.UNIR CONTAS": "MERGE ACCOUNTS",
    "user.ID da companhia": "Company ID",
    "user.Digite o ID da companhia que deseja unir a sua conta": "Enter the ID of the company you want to merge",
    "user.Preencha o ID da companhia": "Fill in the company ID",
    "user.O administrador da conta com a qual deseja se unir poderá localizar o ID ao clicar em seu nome de usuário, localizado no menu superior, no canto direito da tela.": "The administrator of the account you wish to merge will be able to find the ID by clicking on your username, located in the top menu, in the right corner of the screen.",
    "user.O administrador da outra conta receberá um e-mail para aceitar sua solicitação. Assim que for aceita, a união das duas contas será realizada!": "The administrator of the other account will receive an e-mail to accept your request. Once accepted, the two accounts will be merged!",
    "user.Não foi possível solicitar a união de contas. Por favor, confirme o ID ou tente mais tarde": "Unable to request account merge. Please confirm ID or try later",
    "user.SOLICITAÇÃO APROVADA COM SUCESSO": "REQUEST SUCCESSFULLY APPROVED",
    "user.AGUARDE ENQUANTO REALIZAMOS A UNIÃO DAS CONTAS. ESTE PROCESSO PODE LEVAR ALGUNS MINUTOS...": "PLEASE WAIT WHILE WE MERGE THE ACCOUNTS. THIS PROCESS MAY TAKE A FEW MINUTES...",
    "user.UNIÃO DE CONTAS FINALIZADA COM SUCESSO! CLIQUE NO BOTÃO ABAIXO PARA ACESSAR A PLATAFORMA.": "MERGE OF ACCOUNTS SUCCESSFULLY COMPLETED! CLICK THE BUTTON BELOW TO ACCESS THE PLATFORM.",
    "user.NÃO CONSEGUIMOS REALIZAR A UNIÃO DAS CONTAS. POR FAVOR, TENTE NOVAMENTE. SE O PROBLEMA PERSISTIR, ENTRE EM CONTATO COM NOSSO SUPORTE.": "WE ARE UNABLE TO MERGE THE ACCOUNTS. PLEASE TRY AGAIN. IF THE PROBLEM PERSISTS, PLEASE CONTACT OUR SUPPORT.",
    "user.possui todos os acessos": "has all access",
    "user.possui o acesso das abas cookbook, meus menus e equipamentos": "has access to the cookbook, my menus and equipment tabs",
    "user.possui apenas o acesso da aba cookbook": "only has access to the cookbook tab",
    "user.possui apenas o acesso da aba equipamentos": "only has access to the equipment tab",
    "user.possui apenas o acesso da aba meus menus": "only has access to the my menus tab",
    "user.Grupo de equipamentos": "Equipment group",
    "user.Informe o telefone do usuário": "Enter the user's phone number",
    "user.Nenhum grupo criado": "No groups created",
    "user.Digite o ID da companhia que terá acesso à sua conta": "Enter the ID of the company that will have access to your account",
    "user.Ao informar um ID para unir contas com sua companhia, esteja ciente de que o novo usuário também se tornará Administrador da conta de sua companhia. É importante informar que a partir do momento em que um usuário aceitar unir contas com sua companhia, a companhia pertencente a ele deixará de existir.":
    "When providing an ID to merge accounts with your company, be aware that the new user will also become an Administrator of your company's account. It is important to inform that from the moment a user agrees to join accounts with your company, the company belonging to them will cease to exist.",
    "user.Exemplo: Sua conta: 001 | Outra conta: 111. Depois de unir contas com você, a outra conta passará a ser 001.": "Example: Your account: 001 | Another account: 111. After merging accounts with you, the other account will become 001.",
    "user.O administrador da outra conta poderá localizar o ID ao clicar em seu nome de usuário, localizado no menu superior, no canto direito da tela.": "The administrator of the other account will be able to locate the ID by clicking on your username, located in the top menu, in the right corner of the screen.",
    "user.Tela de Equipamentos": "Equipment Screen",
    "user.Tela de Meus Menus": "My Menus Screen",
    "user.Tela do Cookbook": "Cookbook Screen",
    "user.Tela de Usuários": "Users Screen",
    "user.Aba de Suporte": "Support Tab",
    "user.Usuário Comum": "Regular User",
    "user.Usuário do Cookbook": "Cookbook User",
    "user.Usuário de Equipamentos": "Equipment User",
    "user.Usuário de Meus Menus": "My Menus User",
    "user.Você deseja excluir seu acesso da plataforma IOK?": "Do you want to delete your access to the IOK platform?",
    "user.Ao fazer isso, você perderá o acesso a todas as ferramentas da plataforma e, para voltar a acessá-la, será necessário ser adicionado à ela novamente.": "By doing this, you will lose access to all platform tools, and to access it again, you will need to be added to it once more.",
    "user.CONFIRMAÇÃO": "CONFIRMATION",
    "user.Confirme sua senha": "Confirm your password",
    "user.Senha incorreta": "Incorrect password",
    "menus.Os equipamentos e menus criados por ele serão transferidos para o seu nome": "The equipment and menus created by him will be transferred to your name.",
    
    //TUTORIAIS 
    "tutorial.Fechar": "Close",
    "tutorial.Fim": "End",
    "tutorial.Próximo": "Next",
    "tutorial.Abrir": "Open",
    "tutorial.Pular tutorial": "Skip tutorial",
    "tutorial.Editar detalhes da receita": "Edit recipe details",
    "tutorial.Agora você pode adicionar mais detalhes às suas receitas e deixá-las ainda mais completas. Clique em Editar detalhes e preencha as informações necessárias.":
    "Now you can add more details to your recipes and make them even more complete. Click Edit details and fill in the necessary information.",
    "tutorial.Salvar edição da receita": "Save recipe edit",
    "tutorial.Depois de informar mais detalhes da receita, clique em Salvar.": "After you have given more recipe details, click Save.",
    "tutorial.Editar registro de um equipamento": "Edit equipment registration",
    "tutorial.Para completar o registro de seus equipamentos, abra o menu lateral, clique em Editar e preencha as informações de Categoria e Loja.":
    "To complete your equipment's registration, open the side menu, click Edit and fill in the Category and Store information.",
    "tutorial.Editar usuário": "Edit user",
    "tutorial.Para completar o cadastro dos usuários, abra o menu lateral, clique em Editar e preencha a informação referente a Loja a qual ele faz parte.":
    "To complete user registration, open the side menu, click Edit and fill in the information regarding the store they are part of.",
    "tutorial.Salvar edições de um equipamento": "Save an equipment's edits",
    "tutorial.Depois de completar o registro de seus equipamentos, clique em Salvar.": "After completing your equipment's registration, click Save.",
    "tutorial.Ao clicar sobre a linha de um equipamento cadastrado em uma loja, você pode visualizar mais estatísticas e informações sobre ele, além de poder solicitar um atendimento ou disparar atualizações.":
    "By clicking on the line of an equipment registered in a store, you can view more statistics and information about it, in addition to being able to request a service or trigger updates.",
    "tutorial.Para visualizar mais informações sobre a loja, como localização e receitas mais preparadas, clique sobre a linha da unidade que deseja analisar.":
    "To view more information about the store, such as location and most prepared recipes, click on the row of the unit you want to analyze.",
    "tutorial.Criar receita": "Create recipe",
    "tutorial.No cookbook você pode criar suas próprias receitas! Clique em Criar Receita e preencha todas as informações necessárias.":
    "In the cookbook you can create your own recipes! Click Create Recipe and fill in all the necessary information.",
    "tutorial.Editar ou excluir um usuário": "Edit or delete an user",
    "tutorial.Para excluir ou editar as informações de um usuário já cadastrado, clique no menu lateral e selecione a opção desejada.":
    "To delete or edit an registered user's information, click on the side menu and select the desired option.",
    "tutorial.Gerenciamento de usuários": "User management",
    "tutorial.Aqui você pode gerenciar seus usuários com mais facilidade. Ao clicar em + Usuário, você poderá adicionar um novo usuário ou criar um novo tipo de usuário.": "Here you can manage your users more easily. By clicking + User, you can add a new user or create a new user type.",
    "tutorial.Suas receitas": "Your recipes",
    "tutorial.Pelo cookbook você também encontra suas próprias receitas, além de poder criá-las! Clique em Receitas Salvas para visualizar as receitas que foram salvas do cookbook da Prática e também as criadas por você.":
    "Through the cookbook you can also find your own recipes, in addition to being abble to create them! Click Saved Recipes to view the saved recipes from Prática's cookbook and the ones created by you.",
    "tutorial.Filtros do Cookbook": "Cookbook filters",
    "tutorial.Para facilitar a navegação pelas receitas, você pode aplicar filtros a elas. Basta clicar no filtro desejado e escolher uma de suas opções.":
    "In order to facilitate the navigation through the recipes, you can apply filters to them. You just have to click on the desired filter and choose one of its options.",
    "tutorial.Cookbook": "Cookbook",
    "tutorial.No cookbook, em Receitas Disponíveis, você encontrará as receitas criadas pelos Chefs da Prática e poderá utilizá-las sempre que quiser.":
    "In the cookbook, in Available Recipes, you will find the recipes created by Prática's Chefs and will be able to use them when you wish.",
    "tutorial.Atualizar equipamentos": "Update equipment",
    "tutorial.Para enviar uma atualização a seus equipamentos, clique em Atualizar Equipamentos, selecione os modelos que deseja atualizar e a forma como deseja realizar essa atualização - via wi-fi ou pen drive. Depois disso, clique em Confirmar.":
    "To send an update to your equipment, click Update Equipment, select the models you wish to update and how you wish to do it - via wi-fi or USB flash drive. After that, click Confirm.",
    "tutorial.Adicionar equipamento": "Add equipment",
    "tutorial.Para adicionar um equipamento à sua conta, clique em Adicionar Equipamento e preencha as informações do modal. Depois disso, clique em Salvar.":
    "To add an equipment to your account, click Add Equipment and fill in the modal information. After that, click Save.",
    "tutorial.Editar equipamento": "Edit equipment",
    "tutorial.Para desvincular um equipamento ou editar suas informações, clique no menu lateral e selecione a opção desejada.":
    "To unlink an equipment or edit its information, click on the side menu and select the desired option.",
    "tutorial.Seus equipamentos": "Your equipment",
    "tutorial.Aqui você visualizará todos os equipamentos cadastrados em sua plataforma.": "Here you will view all the equipment registered in your platform.",
    "tutorial.Restaurar arquivos": "Restore files",
    "tutorial.Para restaurar um arquivo excluído ou deletá-lo permanentemente, clique no menu lateral e selecione a opção desejada.":
    "To restore a deleted file or delete it permanently, click on the side menu and select the desired option.",
    "tutorial.Lixeira": "Trash",
    "tutorial.Os menus excluídos serão mantidos na Lixeira por 30 dias. Depois desse prazo serão excluídos permanentemente.": "The deleted menus will be kept in Trash for 30 days. After this period they will be permanently deleted.",
    "tutorial.Salvar edições de usuário": "Save user edits",
    "tutorial.Depois de completar o cadastro dos usuários, clique em Salvar.": "After completing the user registration, click Save.",
    "tutorial.Criar menu": "Create menu",
    "tutorial.Para criar e personalizar um menu, clique em Criar Menu e preencha as informações necessárias no modal. Você pode editar um menu a qualquer momento.":
    "To create and customize a menu, click Create Menu and fill in the necessary information in the modal. You can edit a menu at any moment.",
    "tutorial.Importar menu": "Import menu",
    "tutorial.Para importar um menu, clique em Importar Menu e selecione o modelo e versão do equipamento.": "To import a menu, click Import Menu and select the equipment model and version.",
    "tutorial.Criar grupo": "Create group",
    "tutorial.Para organizar suas receitas em grupos, clique em Criar Grupo e preencha as informações necessárias no modal.": "To manage your group recipes, click Create Group and fill in the necessary information in the modal.",
    "tutorial.Tipos de usuário": "User types",
    "tutorial.Agora você também pode criar tipos de usuários com permissões específicas para atender melhor a sua organização.": "You can now also create user types with specific permissions to better serve your organization.",
    "tutorial.Gerenciamento de contas": "Account management",
    "tutorial.Se caso outra pessoa da sua organização também migrou a conta principal da empresa, aqui você pode unir as duas contas.": "If someone else in your organization also migrated their main company account, here you can merge the two accounts.",
    "tutorial.Para completar o registro de seus equipamentos, abra o menu lateral, clique em Editar e preencha as informações de Grupo.": "To complete the registration of your equipment, open the side menu, click Edit and fill in the Group information.",
    "tutorial.Para completar o cadastro dos usuários, abra o menu lateral, clique em Editar e preencha a informação referente ao Grupo de equipamentos a qual ele faz parte.": "To complete user registration, open the side menu, click Edit and fill in the information regarding the Equipment Group to which it belongs.",
    "tutorial.Grupos de equipamentos": "Equipment groups",
    "tutorial.Na aba Grupos você pode visualizar os grupos cadastrados e os equipamentos distribuídos entre eles. Além disso, é possível cadastrar novos grupos e editar os já cadastrados.": "In the Groups tab you can view the registered groups and the equipment distributed among them. Furthermore, it is possible to register new groups and edit those already registered.",
    "tutorial.Detalhes de grupos": "Group details",
    "tutorial.Para visualizar mais informações sobre o grupo, como localização e receitas mais preparadas, clique sobre a linha que deseja analisar.": "To view more information about the group, such as location and the most prepared recipes, click on the row you wish to analyze.",
    "tutorial.Equipamentos em grupos": "Equipment in groups",
    "tutorial.Ao clicar sobre a linha de um equipamento cadastrado em um grupo, você pode visualizar mais estatísticas e informações sobre ele, além de poder solicitar um atendimento ou disparar atualizações.": "By clicking on the line of a device registered in a group, you can view more statistics and information about it, in addition to being able to request service or trigger updates.",
    "tutorial.Grupos": "Groups",
    "tutorial.Atualização e cache": "Update and cache",
    "tutorial.Para atualizar a plataforma e corrigir eventuais problemas de cache, clique aqui.": "To update the platform and correct any cache issues, click here.",
    "tutorial.Dados dos equipamentos": "Equipment data",
    "tutorial.Ao clicar sobre a linha de um equipamento, você pode visualizar mais estatísticas e informações sobre ele, como as receitas mais preparadas, limpezas realizadas e outros dados relevantes.": "By clicking on the row of a piece of equipment, you can view more statistics and information about it, such as the most prepared recipes, completed cleanings, and other relevant data.",
    "tutorial.Para alterar o idioma de sua plataforma, clique em Idioma e selecione a linguagem desejada.": "To change the language of your platform, click on Language and select the desired language.",
    "tutorial.Alterar idioma": "Change the language",
    "tutorial.Para editar ou configurar sua conta, clique em seu nome e selecione a opção desejada.": "To edit or configure your account, click on your name and select the desired option.",
    "tutorial.Editar conta": "Edit account",
    "tutorial.Total de Usuários Cadastrados em sua conta.": "Total Users Registered in your account.",
    "tutorial.Home": "Home",
    "tutorial.Localização de seus equipamentos, sendo possível expandir o mapa para melhor visualização;": "Location of your equipment, making it possible to expand the map for better viewing;",
    "tutorial.Atualizações referentes a versão dos equipamentos vinculados a sua conta;": "Updates regarding the version of equipment linked to your account;",
    "tutorial.Total de Receitas Cadastradas;": "Total Registered Recipe;",
    "tutorial.Menus Disponíveis;": "Available Menus;",
    "tutorial.Esta é a sua home! Aqui você encontra um resumo geral sobre sua conta;" : "This is your home page! Here you'll find an overview of your account;",
    "tutorial.Clique nas abas do menu para explorar a plataforma e conhecer tudo o que ela pode oferecer.": "Click on the menu tabs to explore the platform and discover everything it can offer.",
    "tutorial.Exportar menu": "Export menu",
    "tutorial.Depois de personalizar seu menu, exporte-o para seus equipamentos pela internet ou por pen drive.": "After customizing your menu, export it to your devices via the internet or via USB.",
    "tutorial.Na aba Localização você pode visualizar os endereços já cadastrados, além de criar localizações precisas para vincular seus equipamentos a elas.": "In the Location tab you can view the addresses already registered, in addition to creating precise locations to link your equipment to them.",
    "tutorial.Localização": "Location",
    "tutorial.Informações sobre o equipamento": "Equipment information",
    "tutorial.Equipamentos Ligados e quantos estão enviando dados de uso;" : "Connected equipment and how many are sending usage data;",
    
    //RECOVER ACCOUNT
    "recoverAccount.Para prosseguir, selecione a categoria na qual você se encaixa:": "To proceed, select the category you fit into:",
    "recoverAccount.Deseja acessar a plataforma como DISTRIBUIDOR? Crie sua conta clicando em EMPRESA e entre em contato conosco para liberarmos os demais acessos.":
    "Do you wish to access the platform as a DISTRIBUTOR? Create your account by clicking COMPANY and contact us to release the other accesses.",
    "recoverAccount.A qual organização você pertence": "Which organization do you belong to?",
    
    //RECOVER PASSWORD PAGE
    "recoverPassword.E-mail para recuperação de senha":
    "E-mail for password recovery",
    "recoverPassword.Informe o e-mail cadastrado na plataforma":
    "Inform the e-mail registered on the platform",
    "recoverPassword.E-mail inválido. Por favor, verifique":
    "Invalid e-mail. Please, verify",
    "recoverPassword.RECUPERAR SENHA": "RECOVER PASSWORD",
    "recoverPassword.EM BREVE VOCÊ RECEBERÁ UM E-MAIL COM O LINK DE RECUPERAÇÃO DE SENHA":
    "SHORTLY YOU WILL RECEIVE AN E-MAIL WITH THE PASSWORD RECOVERY LINK",
    "recoverPassword.Informe seu e-mail": "Inform your e-mail",
    "recoverPassword.Crie uma nova senha": "Create a new password",
    "recoverPassword.O campo senha deve conter no mínimo 6 caracteres":
    "The password field must have at least 6 characters",
    "recoverPassword.Confirme sua senha": "Confirm password",
    "recoverPassword.As senhas devem ser iguais": "The passwords must match",
    "recoverPassword.ENTRAR": "ENTER",
    "recoverPassword.EM BREVE VOCÊ RECEBERÁ UM E-MAIL PARA CONFIRMAR SUA IDENTIDADE": "SHORTLY YOU WILL RECEIVE AN E-MAIL TO CONFIRM YOUR IDENTITY",
    "recoverPassword.CONTINUAR": "CONTINUE",
    "recoverPassword.CONFIRMAR": "CONFIRM",
    "recoverPassword.Por segurança, o acesso à conta foi bloqueado devido a tentativas de login incorretas.": "For security reasons, access to the account has been blocked due to incorrect login attempts.",
    "recoverPassword.Para desbloquear sua conta, siga as instruções após clicar no botão abaixo:": "To unlock your account, follow the instructions after clicking the button below:",
    "recoverPassword.Desbloquear conta": "Unlock account",
    "recoverPassword.Você recebeu um e-mail para iniciar o desbloqueio de sua conta.": "You have received an email to start unlocking your account.",
    "recoverPassword.Verifique sua caixa de entrada ou spam.": "Check your inbox or spam folder.",
    "recoverPassword.Verifique seu e-mail": "Check your email.",
    "recoverPassword.Informe seu e-mail de login e crie uma nova senha para acessar sua conta.": "Enter your login email and create a new password to access your account.",
    
    // EXPORT
    "export.Limpezas": "Cleanings",
    "export.Eventos": "Events",
    "export.Lista de receitas preparadas": "List of prepared recipes",
    "export.Lista de limpezas realizadas": "List of completed cleanings",
    "export.Lista de eventos ocorridos": "List of occurred events",
    "export.Exportar dados": "Export data",
    "export.Exportar": "Export",
    "export.Informações do equipamento": "Equipment information",
    "export.Dados exportados com sucesso!": "Data exported successfully!",
    "export.Não foi possível exportar os dados. Por favor, tente novamente mais tarde.": "Unable to export data. Please try again later.",
    "export.Detalhes do menu": "Menu details",
    "export.Detalhes de receitas": "Recipe details",
    "export.Detalhes e Passos": "Details and Steps",
    "export.Exportando dados. Em breve o arquivo estará disponível!": "Exporting data. The file will be available soon!",
    "export.Resumo dos passos": "Summary of steps",
    "export.salvar imagem": "save image",
    "export.Nenhum modelo foi selecionado": "No model was selected",
    
    // COMPANIES PAGE
    "company.Procurar companhia": "Search company",
    "company.Adicionar companhia": "Add company",
    "company.AINDA NÃO HÁ COMPANHIAS CADASTRADAS :(": "THERE ARE NO REGISTERED COMPANIES YET :(",
    "company.description.AINDA NÃO HÁ COMPANHIAS CADASTRADAS :(": "Click the button located in the top right corner and add companies.",
    "company.Adicionar": "Add",
    "company.ADICIONAR EQUIPAMENTOS": "ADD EQUIPMENT",
    "company.Preencha pelo menos um número de série": "Enter at least one serial number",
    "company.Informe os números de série": "Enter the serial numbers",
    "company.Número de série": "Serial number",
    "company.Para incluir vários equipamentos, separe-os com ponto e vírgula (;).": "To add multiple devices, separate them with a semicolon (;).",
    "company.Informe o número de série do equipamento que deseja adicionar abaixo.": "Enter the serial number of the device you want to add below.",
    "company.Números de série adicionados com sucesso!": "Serial numbers added successfully!",
    "company.Não foi possível adicionar os números de série. Tente novamente mais tarde": "Could not add serial numbers. Please try again later.",
    "company.adicionar": "add",
    "company.Procurar por companhia ou ID": "Search for company or ID",
    "company.Companhia": "Company",
    "company.E-mail principal": "Primary email",
    "company.Local": "Location",
    "company.Companhia adicionada com sucesso!": "Company added successfully!",
    "company.Não foi possível cadastrar a companhia": "Could not register the company",
    "company.REMOVER COMPANHIA": "REMOVE COMPANY",
    "company.Você deseja remover a companhia definitivamente? Os equipamentos vinculados a ela também serão removidos de sua conta.": "Do you want to permanently remove the company? The equipment linked to it will also be removed from your account.",
    "company.Esta ação não poderá ser desfeita.": "This action cannot be undone.",
    "company.A companhia foi removida com sucesso!": "The company was successfully removed!",
    "company.Não foi possível remover a companhia": "It was not possible to remove the company",
    "company.Quant. de fornos": "Qty. of ovens",
    "company.Fornos conectados": "Connected ovens",
    "company.Fornos não conectados": "Disconnected ovens",
    "company.AINDA NÃO HÁ EQUIPAMENTOS CADASTRADOS :(": "THERE ARE NO REGISTERED EQUIPMENT YET :(",
    "company.description.AINDA NÃO HÁ EQUIPAMENTOS CADASTRADOS :(": "Click the button located in the top right corner and add equipment.",
    "company.excluir equipamento": "Delete equipment",
    "company.Você deseja excluir o equipamento selecionado definitivamente?": "Do you want to permanently delete the selected equipment?",
    "company.Número de série editado com sucesso!": "Serial number successfully edited!",
    "company.Não foi possível editar o número de série. Tente novamente mais tarde": "Could not edit the serial number. Please try again later.",
    "company.Informe o número de série": "Enter the serial number",
    "company.Preencha um número de série": "Fill in a serial number",
    "company.EDITAR EQUIPAMENTO": "EDIT EQUIPMENT",
    "company.Modelo": "Model",
    "company.Cadastro": "Registration",
    "company.Conectado": "Connected",
    "company.SELECIONE EQUIPAMENTOS PARA EXCLUIR": "SELECT EQUIPMENT TO DELETE",
    "company.O equipamento foi removida com sucesso!": "The equipment was successfully removed!",
    "company.Não foi possível remover o equipamento": "It was not possible to remove the equipment",
    "company.Caracteres especiais não são permitidos, exceto o ponto e vírgula (';')": "Special characters are not allowed, except the semicolon (';')",
    "company.Preencha o número de série sem caracteres especiais": "Enter the serial number without special characters",
    "company.Um ou mais números de série já estão provisionados para outra companhia": "One or more serial numbers are already provisioned for another company.",
    "company.Um ou mais números de série já estão conectados na conta de outra companhia": "One or more serial numbers are already connected to another company's account.",
    
    // Error
    "error.Ocorreu um erro ao carregar esta seção": "An error occurred while loading this section",
    "error.Tentar novamente": "Try again",
    
    //DASHBOARDS
    "dashboard.fornos vinculados" : "CONNECTED OVENS",
    "dashboard.ativos" : "Active",
    "dashboard.inativos" : " Inactive",
    "dashboard.sem status" : " No status",
    "dashboard.fornos atualizados" : "UPDATED OVENS",
    "dashboard.com a versão do software mais recente" : "With the latest software version",
    "dashboard.chamados" : "SUPPORT REQUESTS",
    "dashboard.veja mais no app cliente" : "See more in the Client App",
    "dashboard.limpeza diária" : "DAILY CLEANING",
    "dashboard.dos fornos estão em dia" : "of the ovens are up to date",
    "dashboard.top 3" : "Top 3",
    "dashboard.média de execuções de receitas por hora" : "Average recipe executions per hour",
    "dashboard.avisos" : "WARNINGS",
    "dashboard.ver mais" : "See more",
    "dashboard.abertos pela plataforma IOK" : "Opened through the IOK Platform",
    "dashboard.equipamentos" : "Equipment",
    "dashboard.receitas" : "Recipes",
    "dashboard.executada" : "prepared",
    "dashboard.vezes" : "times",
    "dashboard.forno" : "Oven",
    "dashboard.média por hora" : "Average per hour",
    "dashboard.editar" : "edit",
    "dashboard.endereço:" : "Address:",
    "dashboard.cep:" : "ZIP Code:",
    "dashboard.estatísticas" : "Statistics",
    "dashboard.uso de equipamento" : "Equipment usage",
    "dashboard.pico de uso" : "Usage peak",
    "dashboard.receitas mais executadas por equipamento" : "Most prepared recipes per equipment",
    "dashboard.recolher" : "collapse",
    "dashboard.TOROS TC CONECTADOS:" : "TOROS TC CONNECTED:",
    "dashboard.Consumo de energia - Lastro Toro TC" : "Energy Consumption – Lastro Toro TC",
    "dashboard.tootilp": "It is the sum of all recipes prepared on the current day, divided by the number of hours the oven has been on.",
    "dashboard.noResults": "No results found :(",
    "dashboard.Preaquecimento": "Preheating",
    "dashboard.Esfriamento": "Cooling",
    "dashboard.Execução de receitas": "Recipe preparation",
    "dashboard.Execução de receitas TSi": "TSi recipe preparation",
    "dashboard.Modo manual": "Manual mode",
    "dashboard.Limpeza": "Cleaning",
    "dashboard.Porta": "Door",
    "dashboard.Erros e alertas": "Errors and alerts",
    "dashboard.Parâmetros": "Parameters",
    "dashboard.SEM DADOS POR AQUI" : "NO DATA HERE",
    "dashboard.AINDA SEM GRÁFICOS POR AQUI" : "NO CHARTS HERE YET",
    "dashboard.description.AINDA SEM GRÁFICOS POR AQUI" : "Select items from the list on the side to generate charts, or click the row to view more details.",
    "dashboard.sem avisos por aqui" : "NO NOTIFICATIONS HERE",
    
    //INFORMAÇÕES IOK
    "iokInformation.search.placeholder" : "Search article",
    "iokInformation.article.openInHelpCenter": "View article in the Help Center",
    "iokInformation.aboutPlatform.platformFeatures.title": "The platform and its features",
    "iokInformation.aboutPlatform.platformFeatures.linkLabel": "Download full presentation",
    "iokInformation.aboutPlatform.manual.title": "Instruction manual",
    "iokInformation.aboutPlatform.manual.linkLabel": "Download manual",
    "iokInformation.aboutPlatform.privacy.title": "Privacy policy",
    "iokInformation.aboutPlatform.privacy.linkLabel": "Download policy",
    "iokInformation.aboutPlatform.api.title": "External API",
    "iokInformation.aboutPlatform.api.linkLabel": "Download document",
    
    //Telemetry TSI
    "telemetry.EQUIPMENT_TURN_ON": "Equipment turned on",
    "telemetry.SENSORS_VALUES": "Sensor values",
    "telemetry.ERROR_DETECTED": "Error detected",
    "telemetry.TIME_ADDED": "Time added",
    "telemetry.GN_ADDED": "GN added",
    "telemetry.GN_RELEASED": "GN started",
    "telemetry.GN_FINISHED": "GN finished",
    
    "telemetry.HEAVY_CLEANING_CANCELED": "Heavy cleaning canceled",
    "telemetry.CLEANING_CANCELED": "Cleaning canceled",
    "telemetry.CLEANING_RESTARTED": "Cleaning restarted",
    "telemetry.CLEANING_VAPORIZATION_STEP": "Cleaning vaporization step",
    "telemetry.CLEANING_SUPPLY_STEP": "Cleaning supply step",
    "telemetry.CLEANING_CIRCULATION_STEP": "Cleaning circulation step",
    "telemetry.CLEANING_DEPLETION_STEP": "Cleaning depletion step",
    "telemetry.CLEANING_RISING_STEP": "Cleaning rinsing step",
    "telemetry.CLEANING_STARTED": "Cleaning started",
    "telemetry.CLEANING_FINISHED": "Cleaning finished",
    "telemetry.RECOMMENDED_CLEANING": "Recommended cleaning",
    "telemetry.VALID_PASSWORD_CLEANING": "Valid cleaning password",
    "telemetry.INVALID_PASSWORD_CLEANING": "Invalid cleaning password",
    "telemetry.DROP_ENERGY_SUPPLY": "Power supply recovered",
    
    "telemetry.RECIPE_STARTED": "Recipe started",
    "telemetry.RECIPE_FINISHED": "Recipe finished",
    "telemetry.RECIPE_CANCELED": "Recipe canceled",
    "telemetry.RECIPE_STEP_CHANGED": "Recipe step changed",
    "telemetry.RECIPE_PAUSED": "Recipe paused",
    "telemetry.RECIPE_RESUMED": "Recipe resumed",
    "telemetry.RESUME_RECIPE_CANCELED": "Resume recipe canceled",
    
    "telemetry.PRE_HEAT_STARTED": "Preheat started",
    "telemetry.PRE_HEAT_FINISHED": "Preheat finished",
    "telemetry.OPERATION_CONTINUE_STARTED": "Operation continue started",
    "telemetry.OPERATION_CONTINUE_FINISHED": "Operation continue finished",
    "telemetry.HOLD_TEMPERATURE_STARTED": "Hold temperature started",
    "telemetry.HOLD_TEMPERATURE_FINISHED": "Hold temperature finished",
    "telemetry.COOL_DOWN_STARTED": "Cool down started",
    "telemetry.COOL_DOWN_FINISHED": "Cool down finished",
    "telemetry.NOCTURNAL_COOKING_STARTED": "Overnight cooking started",
    "telemetry.NOCTURNAL_COOKING_FINISHED": "Overnight cooking finished",
    "telemetry.SEALING_STARTED": "Sealing started",
    "telemetry.SEALING_FINISHED": "Sealing finished",
    "telemetry.TURBO_GRILL_STARTED": "Turbo Grill started",
    "telemetry.TURBO_GRILL_FINISHED": "Turbo Grill finished",
    "telemetry.TURBO_GRILL_ACTIVATED": "Turbo Grill activated",
    "telemetry.TURBO_GRILL_DISABLED": "Turbo Grill disabled",
    
    "telemetry.MOISTURE_CHANGED": "Moisture changed",
    "telemetry.TURBINE_CHANGED": "Turbine value changed",
    "telemetry.SET_POINT_CHANGED": "Chamber temperature changed",
    "telemetry.STEAM_CHANGED": "Steam changed",
    "telemetry.PROBE_CHANGED": "Probe temperature changed",
    "telemetry.TIME_CHANGED": "Time changed",
    "telemetry.DOOR_OPENED": "Door opened",
    "telemetry.DOOR_CLOSED": "Door closed",
    
    "telemetry.PROBE_CONTROL_SELECTED": "Probe control selected",
    "telemetry.TIME_CONTROL_SELECTED": "Time control selected",
    "telemetry.MANUAL_STEAM_INJECTED": "Manual steam injection",
    "telemetry.AUTOMATIC_STEAM_INJECTED": "Automatic steam injection",
    
    "telemetry.DATABASE_CREATED": "Database created",
    "telemetry.EXIT_FUNCTION": "Function exited",
    "telemetry.CONSUMPTION": "Consumption",
    "telemetry.STANDBY": "Standby",
    
    "telemetry.ANALYTICS_ERROR_BAD_REQUEST": "Analytics error: Bad request",
    "telemetry.ANALYTICS_ERROR_FORBIDDEN": "Analytics error: Access denied",
    "telemetry.ANALYTICS_ERROR_SERVER": "Analytics error: Server failure",
    "telemetry.ANALYTICS_ERROR_UNEXPECTED": "Analytics error: Unexpected",
    "telemetry.ANALYTICS_SUCCESS": "Analytics success",
    
    "telemetry.STEP": "Step",
    "telemetry.STEAM": "Steam",
    "telemetry.PROBE": "Probe",
    "telemetry.TURBINE": "Fan",
    "telemetry.OCCURRENCES": "occurrence(s)",
    "telemetry.FUNC_USER_RECIPE": "User Recipe",
    "telemetry.FUNC_TSI_RECIPE": "TSi Recipe",
    "telemetry.FUNC_DELTA_T": "Delta T",
    "telemetry.FUNC_STEAM": "Steam",
    "telemetry.FUNC_COMBINED_STEAM": "Combined steam",
    "telemetry.FUNC_HOT_AIR": "Hot air",
    "telemetry.FUNC_NOCTURNAL_COOKING": "Nocturnal cooking",
    "telemetry.FUNC_REGENERATE": "Regenerate",
    "telemetry.FUNC_MULTIPLE_COOKING": "Multiple cooking",
    
    "haccp.filterBy": "Filter by",
    "haccp.export.generating": "The HACCP spreadsheet is being generated and will be downloaded automatically shortly.",
    "haccp.voltage": "Voltage",
    "haccp.voltageReading": "Voltage reading",
    "haccp.voltageOscillation": "Voltage oscillation per day",
    "haccp.status.normal": "Normal",
    "haccp.status.attention": "Attention",
    "haccp.status.critical": "Critical",
    "haccp.dateTime": "Date/Time",
    "haccp.errorDetected": "Error/Alert detected",
    "haccp.detected": "detected",
    "haccp.errorTypeLabel": "Error/Alert type",
    "haccp.severityLabel": "Severity",
    "haccp.severity.error": "Error",
    "haccp.severity.alert": "Alert",
    "haccp.error.canNetwork": "CAN network error",
    "haccp.error.chamberSensor": "Chamber sensor error",
    "haccp.error.steamSensor": "Steam sensor error",
    "haccp.error.probeSensor": "Core probe error",
    "haccp.error.noWater": "No water error",
    "haccp.error.panelTemp": "Control panel temp. error",
    "haccp.error.motor": "Motor error",
    "haccp.error.motorComm": "Motor communication error",
    "haccp.error.hygieneIncomplete": "Incomplete hygiene error",
    "haccp.error.familyModel": "Family/model error",
    "haccp.error.boardTemp": "Board temp. error",
    "haccp.error.energyModule": "Energy module error",
    "haccp.error.i2c": "I2C error",
    "haccp.error.gas": "Gas error",
    "haccp.loading": "Loading...",
    "haccp.quantity": "Quantity",
    "haccp.executions": "Executions",
    "haccp.manual.mode": "Mode",
    "haccp.manual.tempC": "Temp (°C)",
    "haccp.manual.timeMin": "Time (min)",
    "haccp.manual.probeC": "Probe (°C)",
    "haccp.manual.steamPct": "Steam %",
    "haccp.cleaning.label": "Cleaning",
    "haccp.cleaning.recommendedLabel": "Recommended cleaning",
    "haccp.cleaning.status.completed": "Completed",
    "haccp.cleaning.status.restarted": "Restarted",
    "haccp.cleaning.status.interrupted": "Interrupted",
    "haccp.status.label": "Status",
    "haccp.error": "Error",
    "haccp.consumption.water": "Water consumption",
    "haccp.consumption.energy": "Energy consumption",
    "haccp.short.temp": "Temp",
    "haccp.short.time": "Time",
    "haccp.day": "Day",
    "haccp.recipeExecutions": "No. of preparations",
    "STEAM": "Steam",
    "COMBINED_STEAM": "Combined steam",
    "PROBE": "Probe",
    "TURBINE": "Turbine",
    "HOT_AIR": "Hot air",
    "NOCTURNAL_COOKING": "Nocturnal cooking",
    "REGENERATE": "Regenerate",
    "MULTIPLE_COOKING": "Multiple cooking",
    "DELTA_T": "Delta T",
    
    //CSAT
    "csat.AVALIE SUA EXPERIÊNCIA": "RATE YOUR EXPERIENCE",
    "csat.Como você avalia sua experiência com": "How do you rate your experience with",
    "csat.Muito insatisfeito": "Very dissatisfied",
    "csat.Insatisfeito": "Dissatisfied",
    "csat.Neutro": "Neutral",
    "csat.Satisfeito": "Satisfied",
    "csat.Muito satisfeito": "Very satisfied",
    "csat.Utilize o espaço abaixo para deixar suas sugestões:": "Use the space below to leave your suggestions:",
    "csat.Digite aqui": "Type here",
    "csat.Obrigado por responder à nossa pesquisa!": "Thank you for answering our survey!",
    "csat.Selecione uma nota para continuar": "Select a rating to continue",
    "csat.Enviar": "Submit",
    "csat.a criação de receitas": "recipe creation",
    "csat.o cadastro de equipamentos": "equipment registration",
    "csat.o cadastro de usuários": "user registration",
    "csat.a criação de menus": "menu creation",
    "csat.a deleção de receitas": "recipe deletion",
    "csat.a reordenação de receitas": "recipe reordering",
    "csat.o envio de software": "software update",
    "csat.o envio de menus": "menu update",
    "csat.o uso de receitas do Cookbook": "Cookbook recipe usage",
  }
};

export default en;

